import React from "react";
import axios from "axios";
import moment from "moment";
import { cloneDeep } from "lodash";
import Cards from "react-credit-cards";
import NotificationSystem from "react-notification-system";
import {
  Card,
  Label,
  Col,
  Row,
  Table,
  Form,
  Input,
  Button,
  CardBody,
  CardHeader,
  ModalHeader,
  Modal,
  ModalBody,
  ModalFooter,
  FormGroup,
  Tooltip,
  UncontrolledCollapse,
  // CardImg,
  CustomInput,
} from "reactstrap";
import { IoMdEye } from "react-icons/io";
import {
  MdEdit,
  MdClose,
  MdFileDownload,
  MdFileUpload,
  MdDeleteForever,
} from "react-icons/md";
import { FiMinusCircle } from "react-icons/fi";
// import { FaRegCheckCircle } from "react-icons/fa";
import {
  BsFillExclamationTriangleFill,
  BsCircleFill,
  BsCheck,
  BsFillQuestionCircleFill,
} from "react-icons/bs";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Select from "react-select";
import Avatar from "../components/Avatar";
import Page from "../components/Page";
import userImage from "../assets/img/user.jpg";
import PageSpinner from "../components/PageSpinner";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";

import * as Server from "../Server";
// import DefaultImage from "../assets/img/defaultUser.png";
import { capitalizeFirstLetter, getAuthUser } from "../GeneralFunctions";

let user = {};

class RushPlayerDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pages: 0,
      limit: 10,
      child: "",
      player: {},
      currentCamps: [],
      expiredCamps: [],
      creditHistory: [],
      showLoader: false,
      viewDefaultImg: true,
      dueNote: "",
      dueHistory: [],
      dueAmount: 0,
      dueAction: "",
      creditAmount: 0,
      action: "",
      notes: "",
      imageUrl: "",
      fileName: "",
      status: "",
      teams: [],
      firstName: "",
      lastName: "",
      playerEmail: "",
      playerPhone: "",
      birthday: "",
      childNote: "",
      uploadKey: "",
      ImageModel: false,
      selectedFile: "",
      selectedIndex: null,
      selectedTeams: [],
      teamOptions: [],
      removeTeamModel: false,
      selectedTeam: {},
      selectedCreditIndex: null,
      dueAmountModel: false,
      creditAmountModel: false,
      phoneUpdateKey: true,
      birthdayUpdateKey: true,
      lastNameUpdateKey: true,
      firstNameUpdateKey: true,
      removePlayerModal: false,
      dueAmountBreakUpModal: false,
      creditAmountBreakUpModal: false,
      changeStatusConfirmationModal: false,
      breakUpNote: "",
      breakUpAmount: null,
      previousBreakUpAmount: null,
      creditBreakUpNote: "",
      creditBreakUpAmount: null,
      previousCreditBreakUpAmount: null,
      addTeamConfirmationModal: false,
      removeEventModal: false,
      selectedCamp: {},
      childNoteUpdateKey: true,
      archivePlayerModal: false,
      childPhoneUpdateKey: true,
      childEmailUpdateKey: true,
      paymentBalance: 0,
      paymentBalanceBreakUp: [],
      statusTooltip: false,
      cardViewModal: false,
      bankViewModal: false,
      stripeCards: [],
      bankAccounts: [],
      deleteCardModal: false,
      deleteBankModal: false,
      paymentMethodId: "",
      type: "",
      addCardCollapse: false,
      addBankCollapse: false,
      cvc: "",
      name: "",
      number: "",
      expiry: "",
      cardType: "",
      focus: "number",
      routing_number: "",
      account_number: "",
      account_holder_name: "",
      confirm_account_number: "",
      viewError: false,
      noteTooltip: false,
      note: "",
      selectedIndexForPaymentBalance: null,
      // camps: [],
      campsOptions: [],
      selectedCampForDueAmount: null,
      selectedCampForCreditAmount: null,
      selectTeamConfirmationModal: false,
      primarySelectedTeam: {},
      allTeamsOptions: [],
      registerParentModal: false,
      registerFormFieldsAdult: [],
      wavierFormFieldsAdult: [],
      adult: [],
      paymentConfirmationModal: false,
      allCamps: [],
      Camps: [],
      Camp: {},
      fullPayment: true,
      installments: 0,
      installmentDates: [],
      installmentDateShow: false,
      includeDueAmount: false,
      totalPrice: 0,
      useCreditAmount: false,
      cashPayment: true,
      // creditAmount: 0,
      // dueAmount: 0,
      campDetail: {},
      campPrice: 0,
      allAdultsOptions: [],
      selectedAdult: null,
      allCreditCardOptions: [],
      selectedCreditCard: null,
      adultPhoneUpdateKey: true,
      adultEmailUpdateKey: true,
      adultPhone: "",
      adultEmail: "",
      linkAccountModal: false,
      linkAccountConfirmantModal: false,
      linkAccountUsers: [],
      globalSearchData: "",
      selectedLinkedAdultIndex: null,
      linkAccountUser: null,
      sendNotificaitonMessage: "",
      sendNotificaitonModal: false,
      playerFileUploadFields: [],
      genderUpdateKey: true,
      addressUpdateKey: true,
      stateUpdateKey: true,
      cityUpdateKey: true,
      zipCodeUpdateKey: true,
      playerGenderSelected: null,
      playerGender: "",
      playerAddress: "",
      playerState: "",
      playerCity: "",
      playerZipCode: "",
    };
  }

  componentDidMount() {
    user = getAuthUser();
    this.getPlayerDetail({ _id: this.props.history.location.state });
  }

  dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(",")[0].indexOf("base64") >= 0)
      byteString = atob(dataURI.split(",")[1]);
    else byteString = unescape(dataURI.split(",")[1]);

    // separate out the mime component
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }

  onSubmit = async (event) => {
    event.preventDefault();
    try {
      let formData = new FormData();
      this.setState({ showLoader: true });
      // if (!this.state.phoneOtpVerified || !this.state.emailOtpVerified) {
      //   throw Error("Verify email and phone first");
      // }
      let adultFileFields = this.state.registerFormFieldsAdult.filter(
        (field) => field.inputType === "dropdown"
      );
      for (let index = 0; index < adultFileFields.length; index++) {
        const adultFileField = adultFileFields[index];
        if (adultFileField.required) {
          if (!this.state.adult[adultFileField.keyName]) {
            throw Error(`Select the ${adultFileField.placeholder}`);
          }
        }
      }
      let adultFileUploadFields = this.state.registerFormFieldsAdult
        .filter((field) => field.inputType === "fileupload")
        .map((field) => Object.assign(field, { for: "adult" }));
      for (let index = 0; index < adultFileUploadFields.length; index++) {
        const adultFileUploadField = adultFileUploadFields[index];
        if (adultFileUploadField.required) {
          if (this.state.adult[adultFileUploadField.keyName]) {
            formData.append(
              [adultFileUploadField.keyName],
              this.state.adult[adultFileUploadField.keyName]
            );
          } else {
            // throw Error(`Select the ${adultFileUploadField.placeholder}`);
            // let blob = this.dataURItoBlob(DefaultImage);
            // formData.append(
            //   [adultFileUploadField.keyName],
            //   blob,
            //   "defaultUser.png"
            // );
          }
        } else {
          if (this.state.adult[adultFileUploadField.keyName])
            formData.append(
              [adultFileUploadField.keyName],
              this.state.adult[adultFileUploadField.keyName]
            );
        }
      }
      formData.append("clubId", this.state.player.clubId);
      formData.append("adult", JSON.stringify(this.state.adult));
      formData.append("parentId", this.state.player._id);
      let deleteKeys = adultFileUploadFields.map((fields) => ({
        keyName: fields.keyName,
        for: fields.for,
      }));
      if (deleteKeys && deleteKeys.length)
        formData.append("deleteKeys", JSON.stringify(deleteKeys));
      let response = await Server.serverRequest(
        {
          url: "rushUser/registerAdult",
          method: "POST",
          data: formData,
        },
        false
      );
      if (response) {
        if (response.success) {
          this.setState({
            showLoader: false,
            adult: [],
          });
          this.toggleRegisterParentModal();
          this.getPlayerDetail({ _id: this.props.history.location.state });
          this.notificationSystem.addNotification({
            message: response.message,
            level: "success",
          });
        }
      }
      window.scrollTo(0, 0);
    } catch (error) {
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
      this.setState({
        showLoader: false,
      });
    }
  };

  payForEvent = async () => {
    try {
      let response;
      this.setState({ showLoader: true });
      if (!this.state.Camp.value) throw Error("Select the event");
      if (this.state.cashPayment) {
        response = await Server.request({
          url: "rushsoccer/player/payForEvent",
          method: "POST",
          data: {
            includeDueAmount: this.state.includeDueAmount,
            useCreditAmount: this.state.useCreditAmount,
            note: this.state.notes,
            fullPayment: this.state.fullPayment,
            campId: this.state.Camp.value,
            parentId: this.state.player._id,
            childId: this.state.player.child._id,
            installments: this.state.installments,
            installmentDates: this.state.installmentDates,
            installmentDateShow: this.state.installmentDateShow,
            quantity: this.state.quantity,
            paymentDoneFrom: "web",
          },
        });
      } else {
        if (!this.state.selectedCreditCard)
          throw Error("Select the credit card for payment");
        let stripeCard = this.state.stripeCards.find(
          (creditCard) =>
            creditCard.paymentMethodId === this.state.selectedCreditCard.value
        );
        if (this.state.fullPayment) {
          response = await Server.request({
            url: "rushsoccer/stripe/pay",
            method: "POST",
            data: {
              includeDueAmount: this.state.includeDueAmount,
              useCreditAmount: this.state.useCreditAmount,
              SPIEvent: false,
              sendEmail: false,
              APIVersion: "v2",
              paymentFor: "child",
              campId: this.state.Camp.value,
              paymentMethodId: stripeCard.paymentMethodId,
              parentId: stripeCard.parentId,
              childId: this.state.player.child._id,
              notes: this.state.notes,
              quantity: this.state.quantity,
              paymentDoneFrom: "web",
            },
          });
        } else {
          response = await Server.request({
            url: "rushsoccer/stripe/interval/pay",
            method: "POST",
            data: {
              payForPlayers: true,
              includeDueAmount: this.state.includeDueAmount,
              useCreditAmount: this.state.useCreditAmount,
              SPIEvent: false,
              sendEmail: false,
              APIVersion: "v2",
              interval: "month",
              paymentFor: "child",
              campId: this.state.Camp.value,
              paymentMethodId: stripeCard.paymentMethodId,
              parentId: stripeCard.parentId,
              childId: this.state.player.child._id,
              notes: this.state.notes,
              installments: this.state.installments,
              installmentDates: this.state.installmentDates,
              installmentDateShow: this.state.installmentDateShow,
              quantity: this.state.quantity,
              paymentDoneFrom: "web",
            },
          });
        }
      }
      if (response) {
        this.setState({ showLoader: false, selectedCreditCard: null }, () =>
          this.getPlayerDetail({ _id: this.props.history.location.state })
        );
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.toggleCampPaymentConfirmationModal();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getPlayerDetail = async (event) => {
    if (!event._id) event.persist();
    try {
      let childId = event._id ? event._id : event.target.value;
      this.setState({
        showLoader: true,
      });
      let response = await Server.request({
        url: "rushsoccer/player/detail",
        method: "POST",
        data: childId,
      });
      if (response) {
        let registerForm = [];
        if (user.connectedUser) {
          await this.getRegistrationForm(user.connectedUser);
        }
        let allTeamsOptions = response.player.teams.map((team) => ({
          value: team._id,
          label: team.name,
        }));
        let primarySelectedTeam = allTeamsOptions.find(
          (teamOption) =>
            teamOption.value === response.player.child.primaryTeamId
        );
        let Camps = response.player.allCamps.map((camp) => ({
          label: camp.name,
          value: camp._id,
        }));
        let allAdultsOptions = [
          {
            label: `${response.player.data.firstName} ${response.player.data.lastName}`,
            value: response.player._id,
          },
          ...response.player.allAdults.map((allAdult) => ({
            label: `${allAdult.data.firstName} ${allAdult.data.lastName}`,
            value: allAdult._id,
          })),
        ];
        let allCreditCardOptions = response.player.allCreditCards.map(
          (creditCard) => ({
            label: `(${creditCard.name})${creditCard.number}`,
            value: creditCard.paymentMethodId,
          })
        );
        let files = response.player.child.data.files;
        if (Array.isArray(files)) {
          let playerFileUploadFields = this.state.playerFileUploadFields;
          playerFileUploadFields.forEach((playerFileUploadField) => {
            let fileExists = files.find(
              (file) => file.name === playerFileUploadField.keyName
            );
            if (!fileExists) {
              response.player.child.data.files.push({
                url: null,
                urlValue: "Not available",
                name: playerFileUploadField.keyName,
                status: "-",
                hidebutton: true,
              });
            }
          });
        }
        this.setState(
          {
            showLoader: false,
            allCreditCardOptions,
            allAdultsOptions,
            allTeamsOptions,
            primarySelectedTeam,
            player: response.player,
            child: response.player.child,
            teams: response.player.teams,
            firstName: response.player.child.data.firstName,
            lastName: response.player.child.data.lastName,
            playerPhone: response.player.child.data.playerPhone,
            playerEmail: response.player.child.data.playerEmail,
            birthday: response.player.child.data.birthday,
            playerGenderSelected: response.player.child.data.gender
              ? response.player.child.data.gender === "male"
                ? {
                    label: "Male",
                    value: "male",
                  }
                : response.player.child.data.gender === "female"
                ? {
                    label: "Female",
                    value: "female",
                  }
                : {}
              : {},
            playerGender: response.player.child.data.gender,
            playerAddress: response.player.child.data.address,
            playerState: response.player.child.data.state,
            playerCity: response.player.child.data.city,
            playerZipCode: response.player.child.data.zipcode,
            childNote: response.player.child.notes,
            viewDefaultImg: response.player.child.data.files.find(
              (file) => file.name === "photo" && file.url
            )
              ? false
              : true,
            currentCamps: response.player.child.camps.filter(
              (camp) =>
                (camp.subscriptionsExpiredAt === null &&
                  (camp.paymentStatus === "paid" ||
                    camp.paymentStatus === "pending")) ||
                (new Date(camp.subscriptionsExpiredAt).getTime() >
                  new Date().getTime() &&
                  (camp.paymentStatus === "paid" ||
                    camp.paymentStatus === "pending"))
            ),
            expiredCamps: response.player.child.camps.filter(
              (camp) =>
                (camp.subscriptionsExpiredAt !== null &&
                  new Date(camp.subscriptionsExpiredAt).getTime() <
                    new Date().getTime()) ||
                (camp.paymentStatus !== "paid" &&
                  camp.paymentStatus !== "pending")
            ),
            paymentBalance: response.player.child.paymentBalance,
            paymentBalanceBreakUp: response.player.child.paymentBalanceBreakUp.reverse(),
            stripeCards: response.player.allCreditCards,
            bankAccounts: response.player.allBankAccounts,
            allCamps: response.player.allCamps,
            Camps,
            campsOptions: Camps,
            adultEmail: response.player.data.email,
            adultPhone: response.player.data.username,
          },
          () => this.getTeamList()
        );
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getRegistrationForm = async (connecteduser) => {
    try {
      this.setState({ showLoader: true });
      if (connecteduser.registerForm) {
        let allFields = connecteduser.registerForm.reduce(
          (previousValue, currentValue) => {
            previousValue.push(...currentValue.fields);
            return previousValue;
          },
          []
        );
        // let playerFields = allFields.filter(
        //   (form) =>
        //     form.for.value === "player" &&
        //     form.inputType !== "fileupload" && //remove fileuploads
        //     form._id !== "2e3b1830-6147-4955-a3b3-b8e3a2db3d14"
        // );
        let adultFields = allFields
          .filter(
            (form) =>
              form.for.value === "adult" && form.inputType !== "fileupload" //remove fileuploads
          )
          .map((field) =>
            field.keyName === "photo"
              ? Object.assign(field, { keyName: "photo1" })
              : field
          );
        let wavierFormFieldsAdult = allFields.filter(
          (form) => form.for.value === "adult" && form.inputType === "waviers"
        );
        // let wavierFormFieldsPlayers = allFields.filter(
        //   (form) => form.for.value === "player" && form.inputType === "waviers"
        // );
        let playerFileUploadFields = allFields.filter(
          (form) =>
            form.for.value === "player" && form.inputType === "fileupload"
        );
        this.setState({
          showLoader: false,
          registerFormFieldsAdult: adultFields,
          wavierFormFieldsAdult,
          playerFileUploadFields,
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  renderPlayerPaymentDetailPage = async (camp, status) => {
    Object.assign(camp, { status: status });
    this.props.history.push({
      pathname: "/playerPaymentDetail",
      state: {
        camp,
        username: this.state.player.data.username,
        playerName: `${this.state.child.data.firstName} ${this.state.child.data.lastName}`,
      },
    });
  };

  CreditAmount = async (event) => {
    event.preventDefault();
    if (this.state.creditAmount <= 0) {
      this.setState({ creditAmount: 0, notes: "" });
      return this.notificationSystem.addNotification({
        message: "Enter amount greater than zero",
        level: "error",
      });
    } else {
      try {
        this.setState({ showLoader: true });
        let response = await Server.serverRequest({
          url: "rushUser/web/credit",
          method: "POST",
          data: {
            parentId: this.state.player._id,
            childId: this.state.child._id,
            notes: this.state.notes,
            creditAmount: this.state.creditAmount,
            action: this.state.action,
            campId: this.state.selectedCampForCreditAmount
              ? this.state.selectedCampForCreditAmount.value
              : null,
            campName: this.state.selectedCampForCreditAmount
              ? this.state.selectedCampForCreditAmount.label
              : null,
          },
        });
        if (response) {
          this.setState({
            showLoader: false,
            creditAmount: 0,
            notes: "",
            action: "",
            selectedCampForCreditAmount: null,
          });
          this.notificationSystem.addNotification({
            message: response.message,
            level: "success",
          });
          this.getPlayerDetail({ _id: this.props.history.location.state });
          this.toggleCreditModel(event);
        }
      } catch (error) {
        this.setState({
          showLoader: false,
          creditAmount: 0,
          notes: "",
          action: "",
        });
        this.notificationSystem.addNotification({
          message: error.message,
          level: "error",
        });
      }
    }
  };

  creditHistory = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "rushUser/web/credit/history",
        method: "POST",
        data: {
          parentId: this.state.player._id,
          childId: this.state.child._id,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          creditHistory: response.creditHistory,
        });
      }
    } catch (error) {
      this.setState({
        showLoader: false,
      });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  dueAmount = async (event) => {
    event.preventDefault();
    if (this.state.dueAmount <= 0) {
      this.setState({ dueAmount: 0 });
      return this.notificationSystem.addNotification({
        message: "Enter amount greater than zero",
        level: "error",
      });
    } else {
      try {
        this.setState({ showLoader: true });
        let response = await Server.serverRequest({
          url: "rushUser/web/due",
          method: "POST",
          data: {
            parentId: this.state.player._id,
            childId: this.state.child._id,
            dueAmount: this.state.dueAmount,
            notes: this.state.dueNote,
            action: this.state.dueAction,
            campId: this.state.selectedCampForDueAmount
              ? this.state.selectedCampForDueAmount.value
              : null,
            campName: this.state.selectedCampForDueAmount
              ? this.state.selectedCampForDueAmount.label
              : null,
          },
        });
        if (response) {
          this.setState({
            showLoader: false,
            dueAmount: 0,
            dueAction: "",
            dueNote: "",
            selectedCampForDueAmount: null,
          });
          this.notificationSystem.addNotification({
            message: response.message,
            level: "success",
          });
          this.getPlayerDetail({ _id: this.props.history.location.state });
          this.toggleDueModel(event);
        }
      } catch (error) {
        this.setState({
          showLoader: false,
          dueAmount: 0,
          dueAction: "",
          dueNote: "",
        });
        this.notificationSystem.addNotification({
          message: error.message,
          level: "error",
        });
      }
    }
  };

  dueHistory = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "rushUser/web/due/history",
        method: "POST",
        data: {
          parentId: this.state.player._id,
          childId: this.state.child._id,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          dueHistory: response.dueHistory,
        });
      }
    } catch (error) {
      this.setState({
        showLoader: false,
      });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updateImageStatus = async (event) => {
    event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "rushUser/images/status",
        method: "POST",
        data: {
          parentId: this.state.player._id,
          childId: this.state.child._id,
          fileName: this.state.fileName,
          status: this.state.status,
          updateFor: "child",
        },
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getPlayerDetail({ _id: this.props.history.location.state });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updateAdultInfo = async (event, type) => {
    event.preventDefault();
    if (type === "adultPhone" && this.state.adultPhone.length < 10) {
      return this.notificationSystem.addNotification({
        message: "Please enter phone 10 digit",
        level: "error",
      });
    }
    let data = {
      parentId: this.state.player._id,
    };
    if (type === "adultPhone") {
      Object.assign(data, {
        update: type,
        oldPhoneNumber: this.state.player.data.username,
        newPhoneNumber: this.state.adultPhone,
      });
      if (data.oldPhoneNumber === data.newPhoneNumber) return;
    }
    if (type === "adultEmail")
      Object.assign(data, {
        update: type,
        email: this.state.adultEmail,
        username: this.state.player.data.username,
      });
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "rushUser/updateAdultPhoneEmail",
        method: "POST",
        data,
      });
      if (response && response.success) {
        this.setState({ showLoader: false, adultEmail: "", adultPhone: "" });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getPlayerDetail({ _id: this.props.history.location.state });
      } else {
        this.setState({
          showLoader: false,
          adultEmail: this.state.player.data.email,
          adultPhone: this.state.player.data.username,
        });
      }
    } catch (error) {
      this.setState({
        showLoader: false,
        adultEmail: this.state.player.data.email,
        adultPhone: this.state.player.data.username,
      });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updatePlayerInfo = async (event, key, name, fileName) => {
    event.preventDefault();
    if (key === "parent" && this.state.player.data.phone.length < 10) {
      return this.notificationSystem.addNotification({
        message: "Please enter phone 10 digit",
        level: "error",
      });
    }
    let formData = new FormData();
    formData.append("registerFor", key);
    formData.append("parentId", this.state.player._id);
    formData.append("childId", this.state.child._id);
    name.length > 0 && formData.append(name, this.state.child.data[name]);
    name === "playerPhone" &&
      formData.append("username", this.state.child.data[name]);
    this.state.selectedFile &&
      formData.append(fileName, this.state.selectedFile);
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "rushUser/user/update",
        method: "POST",
        data: formData,
      });
      if (response) {
        this.setState({ showLoader: false, selectedFile: "", uploadKey: "" });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getPlayerDetail({ _id: this.props.history.location.state });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
    // name === "playerPhone" &&
    //   this.setState((prevState) => ({
    //     child: {
    //       ...prevState.child,
    //       data: {
    //         ...prevState.child.data,
    //         playerPhone: this.state.playerPhone,
    //       },
    //     },
    //   }));
    // name === "playerEmail" &&
    //   this.setState((prevState) => ({
    //     child: {
    //       ...prevState.child,
    //       data: {
    //         ...prevState.child.data,
    //         playerEmail: this.state.playerEmail,
    //       },
    //     },
    //   }));
    key === "parent" &&
      this.setState({
        phoneUpdateKey: !this.state.phoneUpdateKey,
      });
  };

  updatePlayer = async (event, key) => {
    event.preventDefault();
    let data = {
      childId: this.state.child._id,
      parentId: this.state.player._id,
    };
    data[key] = this.state.child[key];
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "rushUser/child/update",
        method: "POST",
        data,
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getPlayerDetail({ _id: this.props.history.location.state });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updatePlayerPaymentBalanceNote = async (id) => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "rushUser/child/update",
        method: "POST",
        data: {
          childId: this.state.child._id,
          parentId: this.state.player._id,
          paymentBalanceBreakUpId: id,
          paymentBreakUpMessage: this.state.note,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          selectedIndexForPaymentBalance: "",
          note: "",
        });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getPlayerDetail({ _id: this.props.history.location.state });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  removePlayer = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "rushUser/player/delete",
        method: "POST",
        data: {
          delete: "child",
          parentId: this.state.player._id,
          childId: this.state.child._id,
        },
      });
      if (response && response.success) {
        this.setState({
          showLoader: false,
        });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.props.history.goBack();
      } else {
        this.setState({
          showLoader: false,
        });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "error",
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  archivePlayer = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "rushUser/player/archive",
        method: "POST",
        data: {
          childId: this.state.child._id,
        },
      });
      if (response && response.success) {
        this.setState({
          showLoader: false,
        });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        // this.props.history.goBack();
        this.getPlayerDetail({ _id: this.props.history.location.state });
      } else {
        this.setState({
          showLoader: false,
        });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "error",
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  unarchivePlayer = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "rushUser/player/unarchive",
        method: "POST",
        data: {
          parentId: this.state.player._id,
          childId: this.state.child._id,
        },
      });
      if (response && response.success) {
        this.setState({
          showLoader: false,
        });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getPlayerDetail({ _id: this.props.history.location.state });
      } else {
        this.setState({
          showLoader: false,
        });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "error",
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  downloadImage = async (event, file) => {
    event.preventDefault();
    this.setState({ showLoader: true });
    try {
      let response = await axios({
        url: file.url,
        method: "GET",
        responseType: "blob",
      });
      if (response) {
        this.setState({ showLoader: false });
        let url = window.URL.createObjectURL(new Blob([response.data]));
        let link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${this.state.child.data.firstName}_${file.name}.jpg`
        );
        document.body.appendChild(link);
        link.click();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updateDueAmountBreakUpValue = async (value) => {
    try {
      if (this.state.breakUpAmount <= 0) {
        return this.notificationSystem.addNotification({
          message: "Enter amount greater than zero",
          level: "error",
        });
      }
      this.setState({ showLoader: true });
      let data = {
        parentId: this.state.player._id,
        childId: this.state.child._id,
        dueAmount: this.state.breakUpAmount,
        notes: this.state.breakUpNote,
        action: "updateBreakUpAmount",
        amountBreakUpId: value._id,
        dueHistoryId: value.dueHistoryId,
        campId: this.state.selectedCampForDueAmount
          ? this.state.selectedCampForDueAmount.value
          : "",
        campName: this.state.selectedCampForDueAmount
          ? this.state.selectedCampForDueAmount.label
          : "",
      };
      let differenceDueAmount =
        this.state.breakUpAmount - this.state.previousBreakUpAmount;
      Object.assign(data, { differenceDueAmount });
      let response = await Server.serverRequest({
        url: "rushUser/web/due",
        method: "POST",
        data,
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getPlayerDetail({ _id: this.props.history.location.state });
      }
      this.toggleDueAmountBreakUpModal();
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
      this.toggleDueAmountBreakUpModal();
    }
  };

  deleteDueAmountBreakUpValue = async (value) => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "rushUser/web/due",
        method: "POST",
        data: {
          parentId: this.state.player._id,
          childId: this.state.child._id,
          dueAmount: value.amount,
          notes: value.note,
          action: "remove",
          amountBreakUpId: value._id,
        },
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getPlayerDetail({ _id: this.props.history.location.state });
      }
      this.toggleDueAmountBreakUpModal();
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
      this.toggleDueAmountBreakUpModal();
    }
  };

  updateCreditAmountBreakUpValue = async (value) => {
    try {
      if (this.state.creditBreakUpAmount <= 0) {
        return this.notificationSystem.addNotification({
          message: "Enter amount greater than zero",
          level: "error",
        });
      }
      this.setState({ showLoader: true });
      let data = {
        parentId: this.state.player._id,
        childId: this.state.child._id,
        creditAmount: this.state.creditBreakUpAmount,
        notes: this.state.creditBreakUpNote,
        action: "updateBreakUpAmount",
        amountBreakUpId: value._id,
        creditHistoryId: value.creditHistoryId,
        campId: this.state.selectedCampForCreditAmount
          ? this.state.selectedCampForCreditAmount.value
          : "",
        campName: this.state.selectedCampForCreditAmount
          ? this.state.selectedCampForCreditAmount.label
          : "",
      };
      let differenceCreditAmount =
        this.state.creditBreakUpAmount - this.state.previousCreditBreakUpAmount;
      Object.assign(data, { differenceCreditAmount });
      let response = await Server.serverRequest({
        url: "rushUser/web/credit",
        method: "POST",
        data,
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getPlayerDetail({ _id: this.props.history.location.state });
      }
      this.toggleCreditAmountBreakUpModal();
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
      this.toggleCreditAmountBreakUpModal();
    }
  };

  deleteCreditAmountBreakUpValue = async (value) => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "rushUser/web/credit",
        method: "POST",
        data: {
          parentId: this.state.player._id,
          childId: this.state.child._id,
          creditAmount: value.amount,
          notes: value.note,
          action: "remove",
          amountBreakUpId: value._id,
        },
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getPlayerDetail({ _id: this.props.history.location.state });
      }
      this.toggleCreditAmountBreakUpModal();
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
      this.toggleCreditAmountBreakUpModal();
    }
  };

  getTeamList = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/club/teamlist",
        method: "GET",
      });
      if (response && response.teams.length) {
        let teamOptions = [];
        let teams = await response.teams.filter(
          (team) => team.players.includes(this.state.child._id) === false
        );
        teams.map((team) =>
          teamOptions.push({
            label: team.name,
            value: team._id,
          })
        );
        this.setState({
          showLoader: false,
          teamOptions,
        });
      } else {
        this.setState({ showLoader: false });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updatePrimaryTeamId = async (event) => {
    event.preventDefault();
    let teamIds = this.state.selectedTeams.map((team) => team.value);
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/player/setPrimaryTeamId",
        method: "POST",
        data: {
          teamId: this.state.primarySelectedTeam.value,
          parentId: this.state.player._id,
          childId: this.state.child._id,
        },
      });
      if (response) {
        this.setState({ showLoader: false });
        this.getPlayerDetail({ _id: this.props.history.location.state });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updateTeams = async (event) => {
    event.preventDefault();
    let teamIds = this.state.selectedTeams.map((team) => team.value);
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/player/addTeams",
        method: "POST",
        data: { teamIds: teamIds, playerId: this.state.child._id },
      });
      if (response) {
        this.getTeamList();
        this.setState({ showLoader: false });
        this.getPlayerDetail({ _id: this.props.history.location.state });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  removeTeam = async (event) => {
    event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/team/removePlayer",
        method: "POST",
        data: {
          teamId: this.state.selectedTeam._id,
          playerId: this.state.child._id,
        },
      });
      if (response) {
        this.getTeamList();
        this.setState({ showLoader: false });
        this.getPlayerDetail({ _id: this.props.history.location.state });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  removeEvent = async (event) => {
    event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/player/removeEvent",
        method: "POST",
        data: {
          transactionId: this.state.selectedCamp.transactionId,
          campId: this.state.selectedCamp.campId,
          parentId: this.state.player._id,
          childId: this.state.child._id,
        },
      });
      if (response) {
        this.setState({ showLoader: false });
        this.getPlayerDetail({ _id: this.props.history.location.state });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  deletePaymentMethod = async () => {
    try {
      this.setState({ showLoader: true });
      let parentId;
      if (this.state.type === "card") {
        let stripeCard = this.state.stripeCards.find(
          (stripeCard) =>
            stripeCard.paymentMethodId === this.state.paymentMethodId
        );
        parentId = stripeCard.parentId;
      } else {
        let bankAccount = this.state.bankAccounts.find(
          (bankAccount) =>
            bankAccount.paymentMethodId === this.state.paymentMethodId
        );
        parentId = bankAccount.parentId;
      }
      let response = await Server.request({
        url: "rushsoccer/deletePaymentMethod",
        method: "POST",
        data: {
          parentId,
          paymentMethodId: this.state.paymentMethodId,
          type: this.state.type,
        },
      });
      if (response) {
        this.setState({ showLoader: false });
        this.getPlayerDetail({ _id: this.props.history.location.state });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  addCreditCard = async (event) => {
    event.preventDefault();
    try {
      this.setState({ showLoader: true });
      if (!this.state.selectedAdult) throw Error("Select the adult");
      let response = await Server.request({
        url: "rushsoccer/addPaymentMethod",
        method: "POST",
        data: {
          type: "card",
          APIVersion: "v2",
          parentId: this.state.selectedAdult.value,
          cvc: this.state.cvc,
          number: this.state.number,
          exp_year: this.state.expiry.length
            ? this.state.expiry.substring(2, 4)
            : "",
          exp_month: this.state.expiry.length
            ? this.state.expiry.substring(0, 2)
            : "",
          cardType: this.state.cardType,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          cvc: "",
          name: "",
          number: "",
          expiry: "",
          cardType: "",
          focus: "number",
          addCardCollapse: false,
        });
        this.getPlayerDetail({ _id: this.props.history.location.state });
        this.toggleCardViewModal();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  addBankAccount = async (event) => {
    event.preventDefault();
    try {
      if (this.state.account_number !== this.state.confirm_account_number) {
        throw Error("Your account numbers don't match.");
      }
      if (!this.state.selectedAdult) throw Error("Select the adult");
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/addPaymentMethod",
        method: "POST",
        data: {
          type: "bank_account",
          APIVersion: "v2",
          parentId: this.state.selectedAdult.value,
          routing_number: this.state.routing_number,
          account_number: this.state.account_number,
          account_holder_name: this.state.account_holder_name,
          confirm_account_number: this.state.confirm_account_number,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          routing_number: "",
          account_number: "",
          account_holder_name: "",
          confirm_account_number: "",
          addBankCollapse: false,
        });
        this.getPlayerDetail({ _id: this.props.history.location.state });
        this.toggleBankViewModal();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  handleTeamChange = async (Teams) => {
    this.setState((prevState) => ({
      selectedTeams: Teams,
    }));
  };

  updateState = async (type, key, value) => {
    if (value === "on") {
      switch (type) {
        case "adult":
          value = !this.state.adult[key];
          break;
        // case "player":
        //   value = !this.state.player[key];
        //   break;
        default:
          break;
      }
    }
    if (key === "phone" || key === "playerPhone") {
      if (value.length > 10) {
        return true;
      }
    }
    switch (type) {
      case "adult":
        this.setState((prevState) => ({
          adult: {
            ...prevState.adult,
            [key]: value,
          },
        }));
        break;
      // case "player":
      //   this.setState((prevState) => ({
      //     player: {
      //       ...prevState.player,
      //       [key]: value,
      //     },
      //   }));
      //   break;
      default:
        break;
    }
  };

  handleChange = async (type, key, event) => {
    const fileUploaded = event.target.files[0];
    switch (type) {
      case "adult":
        this.setState((prevState) => ({
          adult: {
            ...prevState.adult,
            [key]: fileUploaded,
            [`${key}FileName`]: fileUploaded.name,
          },
        }));
        break;
      // case "player":
      //   this.setState((prevState) => ({
      //     player: {
      //       ...prevState.player,
      //       [key]: fileUploaded,
      //       [`${key}FileName`]: fileUploaded.name,
      //     },
      //   }));
      //   break;
      default:
        break;
    }
    event.target.value = null;
  };

  handleCampChange = (camp) => {
    if (camp) {
      let selectedCamp = this.state.allCamps.find(
        (allcamp) => allcamp._id === camp.value
      );
      let totalPrice = selectedCamp.price;
      let creditAmount = 0;
      let dueAmount = 0;
      if (this.state.player.child.creditAmountBreakUp.length) {
        let creditAmountBreakUp = this.state.player.child.creditAmountBreakUp.filter(
          (value) =>
            value.campId === selectedCamp._id ||
            !value.campId ||
            value.campId === ""
        );
        creditAmount = creditAmountBreakUp.reduce((preVal, curVal) => {
          preVal += curVal.amount;
          return preVal;
        }, 0);
      }
      if (this.state.player.child.dueAmountBreakUp.length) {
        let dueAmountBreakUp = this.state.player.child.dueAmountBreakUp.filter(
          (value) =>
            value.campId === selectedCamp._id ||
            !value.campId ||
            value.campId === ""
        );
        dueAmount = dueAmountBreakUp.reduce((preVal, curVal) => {
          preVal += curVal.amount;
          return preVal;
        }, 0);
      }
      totalPrice = totalPrice - creditAmount;
      // totalPrice = this.state.includeDueAmount
      //   ? this.state.dueAmount + totalPrice
      //   : totalPrice;
      this.setState({
        totalPrice: totalPrice > 0 ? totalPrice : 0,
        Camp: camp,
        campPrice: selectedCamp.price,
        installments: selectedCamp.installments || 0,
        installmentDates: selectedCamp.installmentDates || [],
        installmentDateShow:
          selectedCamp.installmentDates && selectedCamp.installmentDates.length
            ? true
            : false,
        includeDueAmount: false,
        useCreditAmount: true,
        campDetail: selectedCamp,
        creditAmount,
        dueAmount,
      });
    } else {
      this.setState({
        totalPrice: 0,
        Camp: {},
        campPrice: 0,
        installments: 0,
        installmentDates: [],
        installmentDateShow: false,
        includeDueAmount: false,
        useCreditAmount: false,
      });
    }
  };

  installmentDates = (key) => {
    let dates =
      this.state.installmentDates.length > 0 ? this.state.installmentDates : [];
    if (key === "add") {
      if (this.state.installmentDates.length !== this.state.installments) {
        let Start =
          this.state.installmentDates.length === 0
            ? 1
            : this.state.installmentDates.length + 1;
        for (let index = Start; index <= this.state.installments; index++) {
          dates.push({ price: 0, date: "", installmentNumber: index });
        }
      }
    } else if (key === "remove") {
      for (
        let index1 = this.state.installments + 1;
        index1 <= this.state.installmentDates.length;
        index1++
      ) {
        dates = dates.filter((date) => date.installmentNumber !== index1);
      }
    }
    this.setState({ installmentDates: dates });
  };

  getTotalPrice = () => {
    let totalPrice = this.state.installmentDates[0].price;
    if (this.state.includeDueAmount)
      totalPrice = totalPrice + this.state.dueAmount;
    if (this.state.useCreditAmount)
      totalPrice = totalPrice - this.state.creditAmount;
    return totalPrice > 0 ? totalPrice : 0;
  };

  toggleCreditModel = (event) => {
    event.preventDefault();
    this.setState({
      creditAmountModel: !this.state.creditAmountModel,
      creditAmount: 0,
      notes: "",
    });
  };

  toggleDueModel = (event) => {
    event.preventDefault();
    this.setState({
      dueAmountModel: !this.state.dueAmountModel,
      dueAmount: 0,
      dueNote: "",
    });
  };

  toggleImageModel = (event, imageUrl) => {
    event.preventDefault();
    this.setState({
      ImageModel: !this.state.ImageModel,
      imageUrl: imageUrl,
    });
  };

  togglechangeStatusConfirmationModal = (e, filename, status) => {
    e.preventDefault();
    this.setState({
      changeStatusConfirmationModal: !this.state.changeStatusConfirmationModal,
      fileName: filename,
      status: status,
    });
  };

  toggleCardViewModal = () => {
    this.setState({
      cardViewModal: !this.state.cardViewModal,
      selectedAdult: null,
    });
  };

  toggleBankViewModal = () => {
    this.setState({
      bankViewModal: !this.state.bankViewModal,
      selectedAdult: null,
    });
  };

  toggleDeleteCardModal = (paymentMethodId, type) => {
    paymentMethodId
      ? this.setState({
          deleteCardModal: !this.state.deleteCardModal,
          paymentMethodId,
          type,
        })
      : this.setState({ deleteCardModal: !this.state.deleteCardModal });
  };

  toggleDeleteBankModal = (paymentMethodId, type) => {
    paymentMethodId
      ? this.setState({
          deleteBankModal: !this.state.deleteBankModal,
          paymentMethodId,
          type,
        })
      : this.setState({ deleteBankModal: !this.state.deleteBankModal });
  };

  toggleRemovePlayerModal = () => {
    this.setState({ removePlayerModal: !this.state.removePlayerModal });
  };

  toggleArchivePlayerModal = () => {
    this.setState({ archivePlayerModal: !this.state.archivePlayerModal });
  };

  toggleRemoveEventModel = (camp) => {
    if (camp) {
      this.setState({
        selectedCamp: camp,
        removeEventModal: !this.state.removeEventModal,
      });
    } else {
      this.setState({ removeEventModal: !this.state.removeEventModal });
    }
  };

  toggleDueAmountBreakUpModal = () => {
    this.setState({
      selectedIndex: null,
      dueAmountBreakUpModal: !this.state.dueAmountBreakUpModal,
    });
  };

  toggleCreditAmountBreakUpModal = () => {
    this.setState({
      selectedCreditIndex: null,
      creditAmountBreakUpModal: !this.state.creditAmountBreakUpModal,
    });
  };

  toggleAddTeamPlayerConfirmationModal = (event) => {
    event.preventDefault();
    this.setState({ selectedTeams: [] });
    this.setState({
      addTeamConfirmationModal: !this.state.addTeamConfirmationModal,
    });
  };

  toggleSelectTeamPlayerConfirmationModal = (event) => {
    event.preventDefault();
    this.setState({
      selectTeamConfirmationModal: !this.state.selectTeamConfirmationModal,
    });
  };

  toggleRemoveTeamModel = (event) => {
    event.preventDefault();
    this.setState({ removeTeamModel: !this.state.removeTeamModel });
  };

  toggleRegisterParentModal = () => {
    this.setState({ registerParentModal: !this.state.registerParentModal });
  };

  toggleCampPaymentConfirmationModal = (Player) => {
    this.setState({
      paymentConfirmationModal: !this.state.paymentConfirmationModal,
      Player: Player ? Player : {},
      Camp: {},
      campPrice: 0,
      notes: "",
      installments: 0,
      fullPayment: true,
      cashPayment: true,
      installmentDates: [],
      installmentDateShow: false,
      includeDueAmount: false,
      useCreditAmount: false,
      totalPrice: 0,
    });
  };

  toggleLinkAccountModal = () => {
    this.setState({ linkAccountModal: !this.state.linkAccountModal });
  };

  toggleLinkAccountConfirmantModal = () => {
    this.setState({
      linkAccountConfirmantModal: !this.state.linkAccountConfirmantModal,
    });
  };

  toggleSendNotificaitonModal = () => {
    this.setState({
      sendNotificaitonMessage: null,
      sendNotificaitonModal: !this.state.sendNotificaitonModal,
    });
  };

  sendNotificaitonToPlayer = async (event) => {
    try {
      event.preventDefault();
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/player/sendNotification",
        method: "POST",
        data: {
          message: this.state.sendNotificaitonMessage,
          username: this.state.player.data.username,
        },
      });
      if (response) {
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.setState({ showLoader: false });
        this.toggleSendNotificaitonModal();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  linkAccount = async () => {
    try {
      if (!this.state.linkAccountUser) throw Error("Select account to link");
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "rushUser/linkAccount",
        method: "POST",
        data: {
          parentId: this.state.player._id,
          linkParentId: this.state.linkAccountUser._id,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          linkAccountUsers: [],
          globalSearchData: "",
          selectedLinkedAdultIndex: null,
          linkAccountUser: null,
        });
        this.toggleLinkAccountConfirmantModal();
        this.toggleLinkAccountModal();
        this.getPlayerDetail({ _id: this.props.history.location.state });
      }
    } catch (error) {
      this.setState({
        showLoader: false,
      });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getAccountsForLinking = async (event) => {
    try {
      event.preventDefault();
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "rushUser/getAccountsForLinking",
        method: "POST",
        data: {
          parentId: this.state.player._id,
          clubId: user.connectUserId,
          globalSearchData: this.state.globalSearchData,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          linkAccountUsers: response.linkAccountUsers,
        });
      }
    } catch (error) {
      this.setState({
        showLoader: false,
      });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page
          title="Player Detail"
          breadcrumbs={[{ name: "Player Detail", active: true }]}
        >
          <Row>
            <Col>
              <Card className="mb-3">
                <CardHeader>
                  <Row className="playerDetailRow">
                    <Col xl={3} lg={3} md={3}>
                      {this.state.viewDefaultImg ? (
                        <Avatar
                          style={{ marginRight: "10px" }}
                          className="profileImg"
                          src={userImage}
                        />
                      ) : (
                        <img
                          className="profileImg"
                          alt=""
                          src={
                            this.state.child.data.files.find(
                              (file) => file.name === "photo"
                            ).url
                          }
                        ></img>
                      )}
                      <div className="mt-3 ml-4 p-2">
                        <Button
                          onClick={(event) => {
                            this.toggleRemovePlayerModal();
                          }}
                        >
                          Delete Player
                        </Button>
                      </div>
                      <div className="mt-1 ml-4 p-2">
                        <Button
                          className="mt-1"
                          onClick={(event) => {
                            this.toggleArchivePlayerModal();
                          }}
                        >
                          {this.state.child.isArchived
                            ? "Unarchive Player"
                            : "Archive Player"}
                        </Button>
                      </div>
                    </Col>
                    <Col xl={9} lg={9} md={9}>
                      <Row
                        style={{
                          marginBottom: "10px",
                          borderBottom: "2px solid #17517b",
                        }}
                      >
                        <Col xl={7} lg={7} md={7}>
                          <h1>
                            {this.state.child.data &&
                              this.state.child.data.firstName}{" "}
                            {this.state.child.data &&
                              this.state.child.data.lastName}
                          </h1>
                        </Col>
                        {!this.state.child.isRemoved &&
                        !this.state.child.isArchived ? (
                          <Col xl={5} lg={5} md={5}>
                            <div className="d-flex flex-fill">
                              <Button
                                className="mb-2 mr-2"
                                onClick={(event) => {
                                  event.persist();
                                  this.setState({
                                    action: "add",
                                    selectedCampForCreditAmount: null,
                                  });
                                  this.toggleCreditModel(event);
                                }}
                              >
                                Add Credit
                              </Button>
                              <Button
                                className="mb-2 mr-2"
                                onClick={(event) => {
                                  event.persist();
                                  this.setState({
                                    dueAction: "add",
                                    selectedCampForDueAmount: null,
                                  });
                                  this.toggleDueModel(event);
                                }}
                              >
                                Add Past Due
                              </Button>
                              {/* <Button
                                className="mb-2"
                                onClick={(event) => {
                                  event.persist();
                                  this.setState({ action: "remove" });
                                  this.toggleCreditModel(event);
                                }}
                              >
                                Remove Credit
                              </Button> */}
                            </div>
                            <div className="d-flex flex-fill">
                              <Button
                                className="mb-2"
                                onClick={() =>
                                  this.toggleSendNotificaitonModal()
                                }
                              >
                                Send Notification
                              </Button>
                              {/* <Button
                                className="mb-2 mr-2"
                                onClick={(event) => {
                                  event.persist();
                                  this.setState({ dueAction: "add" });
                                  this.toggleDueModel(event);
                                }}
                              >
                                Add Past Due
                              </Button>
                              <Button
                                className="mb-2 ml-xl-3"
                                onClick={(event) => {
                                  event.persist();
                                  this.setState({ dueAction: "remove" });
                                  this.toggleDueModel(event);
                                }}
                              >
                                Remove Past Due
                              </Button> */}
                            </div>
                          </Col>
                        ) : null}
                      </Row>
                      <Row>
                        <Col xl={12} lg={12} md={12}>
                          <Row>
                            <Col xl={4} lg={4} md={4}>
                              <strong>First Name</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.firstNameUpdateKey === false && (
                                <div className="d-flex">
                                  <Input
                                    type="text"
                                    value={
                                      this.state.child
                                        ? this.state.child.data.firstName
                                        : ""
                                    }
                                    className="w-50"
                                    onChange={(event) => {
                                      event.persist();
                                      this.setState((prevState) => ({
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            firstName: event.target.value,
                                          },
                                        },
                                      }));
                                    }}
                                  ></Input>
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updatePlayerInfo(
                                        event,
                                        "child",
                                        "firstName"
                                      );
                                      this.setState({
                                        firstNameUpdateKey: !this.state
                                          .firstNameUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) => {
                                      this.setState((prevState) => ({
                                        firstNameUpdateKey: !this.state
                                          .firstNameUpdateKey,
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            firstName: this.state.firstName,
                                          },
                                        },
                                      }));
                                    }}
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.firstNameUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {this.state.child.data
                                      ? this.state.child.data.firstName
                                      : "-"}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        firstNameUpdateKey: !this.state
                                          .firstNameUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Last Name</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.lastNameUpdateKey === false && (
                                <div className="d-flex">
                                  <Input
                                    type="text"
                                    value={
                                      this.state.child
                                        ? this.state.child.data.lastName
                                        : ""
                                    }
                                    className="w-50"
                                    onChange={(event) => {
                                      event.persist();
                                      this.setState((prevState) => ({
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            lastName: event.target.value,
                                          },
                                        },
                                      }));
                                    }}
                                  ></Input>
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updatePlayerInfo(
                                        event,
                                        "child",
                                        "lastName"
                                      );
                                      this.setState({
                                        lastNameUpdateKey: !this.state
                                          .lastNameUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) =>
                                      this.setState((prevState) => ({
                                        lastNameUpdateKey: !this.state
                                          .lastNameUpdateKey,
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            lastName: this.state.lastName,
                                          },
                                        },
                                      }))
                                    }
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.lastNameUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {this.state.child.data
                                      ? this.state.child.data.lastName
                                      : "-"}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        lastNameUpdateKey: !this.state
                                          .lastNameUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Parent Phone</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.adultPhoneUpdateKey === false && (
                                <div className="d-flex">
                                  <Input
                                    type="text"
                                    value={
                                      this.state.adultPhone
                                        ? this.state.adultPhone
                                        : ""
                                    }
                                    className="w-50"
                                    maxLength="10"
                                    onChange={(event) => {
                                      event.persist();
                                      this.setState({
                                        adultPhone: event.target.value,
                                      });
                                    }}
                                  ></Input>
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updateAdultInfo(event, "adultPhone");
                                      this.setState({
                                        adultPhoneUpdateKey: !this.state
                                          .adultPhoneUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) => {
                                      this.setState({
                                        adultPhoneUpdateKey: !this.state
                                          .adultPhoneUpdateKey,
                                        adultPhone: this.state.player.data
                                          ? this.state.player.data.username ||
                                            ""
                                          : "",
                                      });
                                    }}
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.adultPhoneUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {this.state.adultPhone
                                      ? this.state.adultPhone || "-"
                                      : "-"}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        adultPhoneUpdateKey: !this.state
                                          .adultPhoneUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Parent Email</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.adultEmailUpdateKey === false && (
                                <div className="d-flex">
                                  <Input
                                    type="text"
                                    value={
                                      this.state.adultEmail
                                        ? this.state.adultEmail
                                        : ""
                                    }
                                    className="w-50"
                                    onChange={(event) => {
                                      event.persist();
                                      this.setState({
                                        adultEmail: event.target.value,
                                      });
                                    }}
                                  ></Input>
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updateAdultInfo(event, "adultEmail");
                                      this.setState({
                                        adultEmailUpdateKey: !this.state
                                          .adultEmailUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) => {
                                      this.setState({
                                        adultEmailUpdateKey: !this.state
                                          .adultEmailUpdateKey,
                                        adultEmail: this.state.player.data
                                          ? this.state.player.data.email || ""
                                          : "",
                                      });
                                    }}
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.adultEmailUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {this.state.adultEmail
                                      ? this.state.adultEmail || "-"
                                      : "-"}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        adultEmailUpdateKey: !this.state
                                          .adultEmailUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Player Phone</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.childPhoneUpdateKey === false && (
                                <div className="d-flex">
                                  <Input
                                    type="text"
                                    value={
                                      this.state.child
                                        ? this.state.child.data.playerPhone
                                        : ""
                                    }
                                    className="w-50"
                                    onChange={(event) => {
                                      event.persist();
                                      this.setState((prevState) => ({
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            playerPhone: event.target.value,
                                          },
                                        },
                                      }));
                                    }}
                                  ></Input>
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updatePlayerInfo(
                                        event,
                                        "child",
                                        "playerPhone"
                                      );
                                      this.setState({
                                        childPhoneUpdateKey: !this.state
                                          .childPhoneUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) => {
                                      this.setState((prevState) => ({
                                        childPhoneUpdateKey: !this.state
                                          .childPhoneUpdateKey,
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            playerPhone: this.state.playerPhone,
                                          },
                                        },
                                      }));
                                    }}
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.childPhoneUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {this.state.child.data
                                      ? this.state.child.data.playerPhone || "-"
                                      : "-"}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        childPhoneUpdateKey: !this.state
                                          .childPhoneUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Player Email</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.childEmailUpdateKey === false && (
                                <div className="d-flex">
                                  <Input
                                    type="text"
                                    value={
                                      this.state.child
                                        ? this.state.child.data.playerEmail
                                        : ""
                                    }
                                    className="w-50"
                                    onChange={(event) => {
                                      event.persist();
                                      this.setState((prevState) => ({
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            playerEmail: event.target.value,
                                          },
                                        },
                                      }));
                                    }}
                                  ></Input>
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updatePlayerInfo(
                                        event,
                                        "child",
                                        "playerEmail"
                                      );
                                      this.setState({
                                        childEmailUpdateKey: !this.state
                                          .childEmailUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) => {
                                      this.setState((prevState) => ({
                                        childEmailUpdateKey: !this.state
                                          .childEmailUpdateKey,
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            playerEmail: this.state.playerEmail,
                                          },
                                        },
                                      }));
                                    }}
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.childEmailUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {this.state.child.data
                                      ? this.state.child.data.playerEmail || "-"
                                      : "-"}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        childEmailUpdateKey: !this.state
                                          .childEmailUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Date of Birth</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.birthdayUpdateKey === false && (
                                <div className="d-flex">
                                  <Input
                                    type="date"
                                    value={
                                      this.state.child
                                        ? new Date(
                                            this.state.child.data.birthday
                                          )
                                            .toISOString()
                                            .substr(0, 10)
                                        : ""
                                    }
                                    className="w-50"
                                    onChange={(event) => {
                                      event.persist();
                                      event.target.value !== "" &&
                                        this.setState((prevState) => ({
                                          child: {
                                            ...prevState.child,
                                            data: {
                                              ...prevState.child.data,
                                              birthday: event.target.value,
                                            },
                                          },
                                        }));
                                    }}
                                  ></Input>
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updatePlayerInfo(
                                        event,
                                        "child",
                                        "birthday"
                                      );
                                      this.setState({
                                        birthdayUpdateKey: !this.state
                                          .birthdayUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) => {
                                      event.persist();
                                      this.setState((prevState) => ({
                                        birthdayUpdateKey: !this.state
                                          .birthdayUpdateKey,
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            birthday: this.state.birthday,
                                          },
                                        },
                                      }));
                                    }}
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.birthdayUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {(this.state.child.data &&
                                      moment
                                        .utc(this.state.child.data.birthday)
                                        .format("LL")) ||
                                      "-"}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        birthdayUpdateKey: !this.state
                                          .birthdayUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Gender</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.genderUpdateKey === false && (
                                <div className="d-flex">
                                  <Select
                                    options={[
                                      {
                                        label: "Male",
                                        value: "male",
                                      },
                                      {
                                        label: "Female",
                                        value: "female",
                                      },
                                    ]}
                                    value={this.state.playerGenderSelected}
                                    onChange={(result) => {
                                      this.setState((prevState) => ({
                                        playerGenderSelected: result,
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            gender: result.value,
                                          },
                                        },
                                      }));
                                    }}
                                    className="w-50 basic-single"
                                  />
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updatePlayerInfo(
                                        event,
                                        "child",
                                        "gender"
                                      );
                                      this.setState({
                                        genderUpdateKey: !this.state
                                          .genderUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) => {
                                      this.setState((prevState) => ({
                                        genderUpdateKey: !this.state
                                          .genderUpdateKey,
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            gender: this.state.playerGender,
                                          },
                                        },
                                      }));
                                    }}
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.genderUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {this.state.child
                                      ? this.state.child.data.gender || "-"
                                      : ""}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        genderUpdateKey: !this.state
                                          .genderUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Address</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.addressUpdateKey === false && (
                                <div className="d-flex">
                                  <Input
                                    type="text"
                                    value={
                                      this.state.child
                                        ? this.state.child.data.address
                                        : ""
                                    }
                                    className="w-50"
                                    onChange={(event) => {
                                      event.persist();
                                      this.setState((prevState) => ({
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            address: event.target.value,
                                          },
                                        },
                                      }));
                                    }}
                                  ></Input>
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updatePlayerInfo(
                                        event,
                                        "child",
                                        "address"
                                      );
                                      this.setState({
                                        addressUpdateKey: !this.state
                                          .addressUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) => {
                                      this.setState((prevState) => ({
                                        addressUpdateKey: !this.state
                                          .addressUpdateKey,
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            address: this.state.playerAddress,
                                          },
                                        },
                                      }));
                                    }}
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.addressUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {this.state.child
                                      ? this.state.child.data.address || "-"
                                      : ""}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        addressUpdateKey: !this.state
                                          .addressUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>State</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.stateUpdateKey === false && (
                                <div className="d-flex">
                                  <Input
                                    type="text"
                                    value={
                                      this.state.child
                                        ? this.state.child.data.state
                                        : ""
                                    }
                                    className="w-50"
                                    onChange={(event) => {
                                      event.persist();
                                      this.setState((prevState) => ({
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            state: event.target.value,
                                          },
                                        },
                                      }));
                                    }}
                                  ></Input>
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updatePlayerInfo(
                                        event,
                                        "child",
                                        "state"
                                      );
                                      this.setState({
                                        stateUpdateKey: !this.state
                                          .stateUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) => {
                                      this.setState((prevState) => ({
                                        stateUpdateKey: !this.state
                                          .stateUpdateKey,
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            state: this.state.playerState,
                                          },
                                        },
                                      }));
                                    }}
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.stateUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {this.state.child
                                      ? this.state.child.data.state || "-"
                                      : ""}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        stateUpdateKey: !this.state
                                          .stateUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>City</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.cityUpdateKey === false && (
                                <div className="d-flex">
                                  <Input
                                    type="text"
                                    value={
                                      this.state.child
                                        ? this.state.child.data.city
                                        : ""
                                    }
                                    className="w-50"
                                    onChange={(event) => {
                                      event.persist();
                                      this.setState((prevState) => ({
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            city: event.target.value,
                                          },
                                        },
                                      }));
                                    }}
                                  ></Input>
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updatePlayerInfo(
                                        event,
                                        "child",
                                        "city"
                                      );
                                      this.setState({
                                        cityUpdateKey: !this.state
                                          .cityUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) => {
                                      this.setState((prevState) => ({
                                        cityUpdateKey: !this.state
                                          .cityUpdateKey,
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            city: this.state.playerCity,
                                          },
                                        },
                                      }));
                                    }}
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.cityUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {this.state.child
                                      ? this.state.child.data.city || "-"
                                      : ""}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        cityUpdateKey: !this.state
                                          .cityUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>ZipCode</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.zipCodeUpdateKey === false && (
                                <div className="d-flex">
                                  <Input
                                    type="text"
                                    value={
                                      this.state.child
                                        ? this.state.child.data.zipcode
                                        : ""
                                    }
                                    className="w-50"
                                    onChange={(event) => {
                                      event.persist();
                                      this.setState((prevState) => ({
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            zipcode: event.target.value,
                                          },
                                        },
                                      }));
                                    }}
                                  ></Input>
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updatePlayerInfo(
                                        event,
                                        "child",
                                        "zipcode"
                                      );
                                      this.setState({
                                        zipCodeUpdateKey: !this.state
                                          .zipCodeUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) => {
                                      this.setState((prevState) => ({
                                        zipCodeUpdateKey: !this.state
                                          .zipCodeUpdateKey,
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            zipcode: this.state.playerZipCode,
                                          },
                                        },
                                      }));
                                    }}
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.zipCodeUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {this.state.child
                                      ? this.state.child.data.zipcode || "-"
                                      : ""}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        zipCodeUpdateKey: !this.state
                                          .zipCodeUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Past Due</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              <div className="d-flex">
                                <p>
                                  {(this.state.child &&
                                    Number(this.state.child.dueAmount).toFixed(
                                      2
                                    )) ||
                                    "0"}
                                </p>
                                <IoMdEye
                                  size="20px"
                                  className="ml-2"
                                  style={{
                                    cursor: "pointer",
                                    marginTop: "2px",
                                  }}
                                  onClick={this.toggleDueAmountBreakUpModal}
                                ></IoMdEye>
                              </div>
                            </Col>
                            {/* <Col xl={4} lg={4} md={4}>
                                <strong>Recent Note For Due</strong>
                              </Col>
                              <Col xl={8} lg={8} md={8}>
                                <p>
                                  {(this.state.child &&
                                    this.state.child.dueNote) ||
                                    "-"}
                                </p>
                              </Col> */}
                            <Col xl={4} lg={4} md={4}>
                              <strong>Credit Balance</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              <div className="d-flex">
                                <p>
                                  {(this.state.child &&
                                    Number(
                                      this.state.child.creditAmount
                                    ).toFixed(2)) ||
                                    "0"}
                                </p>
                                <IoMdEye
                                  size="20px"
                                  className="ml-2"
                                  style={{
                                    cursor: "pointer",
                                    marginTop: "2px",
                                  }}
                                  onClick={this.toggleCreditAmountBreakUpModal}
                                ></IoMdEye>
                              </div>
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Registration Date</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              <p>
                                {(this.state.child &&
                                  moment
                                    .utc(this.state.child.createdAt)
                                    .format("LL")) ||
                                  "-"}
                              </p>
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Credit Card on file</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              <p>
                                {(this.state.player &&
                                  this.state.player.creditCardAdded) ||
                                  "-"}
                                <IoMdEye
                                  size="20px"
                                  className="ml-2"
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  onClick={this.toggleCardViewModal}
                                ></IoMdEye>
                              </p>
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Bank Account on file</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              <p>
                                {(this.state.player &&
                                  this.state.player.bankAccountAdded) ||
                                  "-"}
                                <IoMdEye
                                  size="20px"
                                  className="ml-2"
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  onClick={this.toggleBankViewModal}
                                ></IoMdEye>
                              </p>
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Note</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.childNoteUpdateKey === false && (
                                <div className="d-flex">
                                  <Input
                                    type="text"
                                    value={
                                      this.state.child
                                        ? this.state.child.notes
                                        : ""
                                    }
                                    className="w-50 mb-2"
                                    onChange={(event) => {
                                      event.persist();
                                      this.setState((prevState) => ({
                                        child: {
                                          ...prevState.child,
                                          notes: event.target.value,
                                        },
                                      }));
                                    }}
                                  ></Input>
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updatePlayer(event, "notes");
                                      this.setState({
                                        childNoteUpdateKey: !this.state
                                          .childNoteUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) => {
                                      this.setState((prevState) => ({
                                        childNoteUpdateKey: !this.state
                                          .childNoteUpdateKey,
                                        child: {
                                          ...prevState.child,
                                          notes: this.state.childNote,
                                        },
                                      }));
                                    }}
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.childNoteUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {this.state.child && this.state.child.notes
                                      ? this.state.child.notes
                                      : "-"}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        childNoteUpdateKey: !this.state
                                          .childNoteUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            {user && user.name === "San Jose Rush" ? (
                              <>
                                <Col xl={4} lg={4} md={4}>
                                  <strong>Program</strong>
                                </Col>
                                <Col xl={8} lg={8} md={8}>
                                  <div className="d-flex">
                                    <p>
                                      {this.state.child &&
                                      this.state.child.data.event
                                        ? this.state.child.data.event
                                        : "-"}
                                    </p>
                                  </div>
                                </Col>
                              </>
                            ) : null}
                            <Col xl={4} lg={4} md={4}>
                              <strong>Team Names</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              <p>
                                {this.state.teams.length
                                  ? this.state.teams.map((team, index) => (
                                      <div key={index}>
                                        {team.name}
                                        <FiMinusCircle
                                          size={20}
                                          onClick={(event) => {
                                            event.persist();
                                            this.setState(
                                              { selectedTeam: team },
                                              () =>
                                                this.toggleRemoveTeamModel(
                                                  event
                                                )
                                            );
                                          }}
                                          className="ml-2"
                                          style={{ cursor: "pointer" }}
                                        />
                                        {/* {team._id ===
                                        this.state.player.child
                                          .primaryTeamId ? (
                                        <FaRegCheckCircle
                                          size={20}
                                          className="ml-2"
                                        ></FaRegCheckCircle>
                                      ) : null} */}
                                      </div>
                                    ))
                                  : "-"}
                              </p>
                              {!this.state.child.isRemoved &&
                              !this.state.child.isArchived ? (
                                <Button
                                  onClick={(event) =>
                                    this.toggleAddTeamPlayerConfirmationModal(
                                      event
                                    )
                                  }
                                >
                                  Add To Team
                                </Button>
                              ) : null}
                              {/* <Button
                                className="ml-2"
                                onClick={(event) =>
                                  this.toggleSelectTeamPlayerConfirmationModal(
                                    event
                                  )
                                }
                              >
                                Select Primary Team
                              </Button> */}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="playerDetailRow">
                    <Col xl={12} lg={12} md={12}>
                      <Row
                        style={{
                          marginBottom: "10px",
                          borderBottom: "2px solid #17517b",
                        }}
                      >
                        <Col xs={6}>
                          <h3>Family Detail</h3>
                        </Col>
                        {user.connectedUser &&
                        !this.state.child.isRemoved &&
                        !this.state.child.isArchived ? (
                          <Col xs={6} style={{ textAlign: "right" }}>
                            {!user.connectedUser.SPIEvent && (
                              <Button
                                className="mr-1"
                                onClick={() => this.toggleRegisterParentModal()}
                              >
                                Add Adult
                              </Button>
                            )}
                            <Button
                              onClick={() => this.toggleLinkAccountModal()}
                            >
                              Link account
                            </Button>
                          </Col>
                        ) : null}
                      </Row>
                    </Col>
                    <Col xl={12} lg={12} md={12}>
                      <Tabs id="tab1">
                        <TabList>
                          <Tab>Parent 1</Tab>
                          {this.state.player.allAdults &&
                          this.state.player.allAdults.length
                            ? this.state.player.allAdults.map(
                                (adult, index) => (
                                  <Tab key={index}>Parent {index + 2}</Tab>
                                )
                              )
                            : null}
                        </TabList>
                        <TabPanel>
                          <Row>
                            <Col xl={6} lg={6} md={6}>
                              <strong>First Name</strong>
                            </Col>
                            <Col xl={6} lg={6} md={6}>
                              <p className="capitalizeText">
                                {this.state.player.data &&
                                  this.state.player.data.firstName}
                              </p>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={6} lg={6} md={6}>
                              <strong>Last Name</strong>
                            </Col>
                            <Col xl={6} lg={6} md={6}>
                              <p className="capitalizeText">
                                {this.state.player.data &&
                                  this.state.player.data.lastName}
                              </p>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={6} lg={6} md={6}>
                              <strong>Phone</strong>
                            </Col>
                            <Col xl={6} lg={6} md={6}>
                              {/* {this.state.phoneUpdateKey === false && (
                              <div className="d-flex">
                                <Input
                                  type="number"
                                  value={
                                    this.state.player
                                      ? this.state.player.data.phone
                                      : ""
                                  }
                                  className="w-50"
                                  onChange={(event) => {
                                    event.persist();
                                    event.target.value.length <= 10 &&
                                      this.setState((prevState) => ({
                                        player: {
                                          ...prevState.player,
                                          data: {
                                            ...prevState.player.data,
                                            phone: event.target.value,
                                          },
                                        },
                                      }));
                                  }}
                                ></Input>

                                <Button
                                  onClick={(event) => {
                                    this.updatePlayerInfo(event, "parent");
                                  }}
                                  className="ml-2 "
                                >
                                  update
                                </Button>
                              </div>
                            )}
                            {this.state.phoneUpdateKey === true && (
                              <div className="d-flex">
                                <p>
                                  {this.state.player.data &&
                                    this.state.player.data.phone}
                                </p>
                                <Label
                                  onClick={(event) => {
                                    this.setState({
                                      phoneUpdateKey: !this.state
                                        .phoneUpdateKey,
                                    });
                                  }}
                                  className="ml-2 "
                                >
                                  <MdEdit size="20px"></MdEdit>
                                </Label>
                              </div>
                            )} */}
                              <p className="capitalizeText">
                                {this.state.player.data &&
                                this.state.player.data.phone
                                  ? this.state.player.data.phone
                                  : "-"}
                              </p>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={6} lg={6} md={6}>
                              <strong>Email</strong>
                            </Col>
                            <Col xl={6} lg={6} md={6}>
                              <p className="lowercaseText">
                                {this.state.player.data &&
                                this.state.player.data.email
                                  ? this.state.player.data.email
                                  : "-"}
                              </p>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={6} lg={6} md={6}>
                              <strong>RelationShip With Child</strong>
                            </Col>
                            <Col xl={6} lg={6} md={6}>
                              <p className="capitalizeText">
                                {this.state.player.data &&
                                this.state.player.data.relationShipWithChild
                                  ? this.state.player.data.relationShipWithChild
                                  : "-"}
                              </p>
                            </Col>
                          </Row>
                        </TabPanel>
                        {this.state.player.allAdults &&
                        this.state.player.allAdults.length
                          ? this.state.player.allAdults.map((adult, index) => (
                              <TabPanel key={index}>
                                <Row>
                                  <Col xl={6} lg={6} md={6}>
                                    <strong>First Name</strong>
                                  </Col>
                                  <Col xl={6} lg={6} md={6}>
                                    <p className="capitalizeText">
                                      {adult.data && adult.data.firstName
                                        ? adult.data.firstName
                                        : "-"}
                                    </p>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col xl={6} lg={6} md={6}>
                                    <strong>Last Name</strong>
                                  </Col>
                                  <Col xl={6} lg={6} md={6}>
                                    <p className="capitalizeText">
                                      {adult.data && adult.data.lastName
                                        ? adult.data.lastName
                                        : "-"}
                                    </p>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col xl={6} lg={6} md={6}>
                                    <strong>Phone</strong>
                                  </Col>
                                  <Col xl={6} lg={6} md={6}>
                                    <p className="capitalizeText">
                                      {adult.data && adult.data.phone
                                        ? adult.data.phone
                                        : "-"}
                                    </p>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col xl={6} lg={6} md={6}>
                                    <strong>Email</strong>
                                  </Col>
                                  <Col xl={6} lg={6} md={6}>
                                    <p className="lowercaseText">
                                      {adult.data && adult.data.email
                                        ? adult.data.email
                                        : "-"}
                                    </p>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col xl={6} lg={6} md={6}>
                                    <strong>RelationShip With Child</strong>
                                  </Col>
                                  <Col xl={6} lg={6} md={6}>
                                    <p className="capitalizeText">
                                      {adult.data &&
                                      adult.data.relationShipWithChild
                                        ? adult.data.relationShipWithChild
                                        : "-"}
                                    </p>
                                  </Col>
                                </Row>
                              </TabPanel>
                            ))
                          : null}
                      </Tabs>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Image</th>
                            <th>Name</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {typeof this.state.child === "object" &&
                          this.state.child !== null
                            ? this.state.child.data.files.length
                              ? this.state.child.data.files.map(
                                  (file, index) => (
                                    <tr key={index}>
                                      {file.hidebutton ? (
                                        <td>{file.urlValue}</td>
                                      ) : (
                                        <td
                                          style={{
                                            cursor: "pointer",
                                          }}
                                          onClick={(e) =>
                                            this.toggleImageModel(e, file.url)
                                          }
                                        >
                                          <img
                                            src={file.url}
                                            className="img-responsive"
                                            alt=""
                                            style={{ width: "150px" }}
                                          />
                                        </td>
                                      )}
                                      <td>{file.name ? file.name : "-"}</td>
                                      <td>{file.status}</td>
                                      <td>
                                        <div className="d-flex">
                                          {!file.hidebutton && (
                                            <>
                                              <Button
                                                onClick={(e) =>
                                                  this.togglechangeStatusConfirmationModal(
                                                    e,
                                                    file.name,
                                                    "accepted"
                                                  )
                                                }
                                                className="mr-3"
                                              >
                                                Accept
                                              </Button>
                                              <Button
                                                onClick={(e) =>
                                                  this.togglechangeStatusConfirmationModal(
                                                    e,
                                                    file.name,
                                                    "rejected"
                                                  )
                                                }
                                              >
                                                Reject
                                              </Button>
                                              <Button
                                                className="ml-3"
                                                onClick={(event) =>
                                                  this.downloadImage(
                                                    event,
                                                    file
                                                  )
                                                }
                                              >
                                                <MdFileDownload size="20px"></MdFileDownload>
                                              </Button>
                                            </>
                                          )}
                                          <Button
                                            className="p-0 ml-3"
                                            style={{
                                              width: "45px",
                                              height: "40px",
                                            }}
                                          >
                                            <Label
                                              htmlFor={file.name}
                                              className="w-100 h-100 mt-2"
                                              style={{
                                                cursor: "pointer",
                                              }}
                                            >
                                              <MdFileUpload size="21px"></MdFileUpload>
                                            </Label>
                                          </Button>
                                          <Input
                                            id={file.name}
                                            style={{ display: "none" }}
                                            type="file"
                                            accept="image/*"
                                            onChange={(event) => {
                                              this.setState({
                                                selectedFile:
                                                  event.target.files[0],
                                                uploadKey: file.name,
                                              });
                                            }}
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div className="d-flex">
                                          <Label className="m-0 p-0">
                                            {this.state.selectedFile &&
                                            file.name === this.state.uploadKey
                                              ? this.state.selectedFile.name
                                              : ""}
                                          </Label>
                                          {this.state.selectedFile &&
                                          file.name === this.state.uploadKey ? (
                                            <div className="ml-3">
                                              <Label
                                                className="mr-3"
                                                onClick={(event) =>
                                                  this.updatePlayerInfo(
                                                    event,
                                                    "child",
                                                    "",
                                                    file.name
                                                  )
                                                }
                                                style={{
                                                  cursor: "pointer",
                                                }}
                                              >
                                                <BsCheck size="30px"></BsCheck>
                                              </Label>
                                              <Label
                                                onClick={() =>
                                                  this.setState({
                                                    selectedFile: "",
                                                    uploadKey: "",
                                                  })
                                                }
                                                style={{
                                                  cursor: "pointer",
                                                }}
                                              >
                                                <MdClose size="30px"></MdClose>
                                              </Label>
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                  )
                                )
                              : null
                            : ""}
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Row
                    className="playerDetailRow"
                    style={{ background: "white" }}
                  >
                    <Tabs style={{ width: "100%" }}>
                      <TabList>
                        <Tab>Current Registrations</Tab>
                        <Tab>Past Registrations</Tab>
                        {/* <Tab>Credit History</Tab> */}
                        {/* <Tab>Due History</Tab> */}
                        <Tab>Payment Balance History</Tab>
                        {!this.state.child.isRemoved &&
                        !this.state.child.isArchived ? (
                          <Button
                            style={{ float: "right" }}
                            onClick={(event) => {
                              event.stopPropagation();
                              this.toggleCampPaymentConfirmationModal();
                            }}
                          >
                            Pay for event
                          </Button>
                        ) : null}
                      </TabList>
                      <TabPanel>
                        <Table striped hover responsive>
                          <thead>
                            <tr>
                              <th>Event Name</th>
                              <th>State</th>
                              <th>Registration</th>
                              <th>Payment Status</th>
                              <th>Price</th>
                              {/* <th>Pending Price</th>
                              <th>Credit Amount</th>
                              <th>Past Due Amount</th> */}
                              <th>Notes</th>
                              <th>View Transaction</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.currentCamps.length > 0 ? (
                              this.state.currentCamps.map((camp, index) => (
                                <tr key={index}>
                                  <td>
                                    {capitalizeFirstLetter(camp.campName)}
                                  </td>
                                  <td>
                                    {new Date().getTime() >
                                      new Date(
                                        camp.subscriptionsStartedAt
                                      ).getTime() ||
                                    new Date().setHours(12, 0, 0, 0) ===
                                      new Date(
                                        camp.subscriptionsStartedAt
                                      ).setHours(12, 0, 0, 0) ? (
                                      camp.pausePayment ? (
                                        <BsCircleFill color="yellow"></BsCircleFill>
                                      ) : (
                                        <BsCircleFill color="#0cf10c"></BsCircleFill>
                                      )
                                    ) : (
                                      <BsCircleFill></BsCircleFill>
                                    )}
                                  </td>
                                  <td>
                                    {moment.utc(camp.createdAt).format("LL")}
                                  </td>
                                  <td>
                                    {capitalizeFirstLetter(camp.paymentStatus)}
                                  </td>
                                  <td>{camp.price.toFixed(2)}</td>
                                  {/* <td>{camp.pendingPrice.toFixed(2)}</td>
                                  <td>
                                    {camp.creditAmount
                                      ? camp.creditAmount.toFixed(2)
                                      : (0).toFixed(2)}
                                  </td>
                                  <td>
                                    {camp.dueAmount
                                      ? camp.dueAmount.toFixed(2)
                                      : (0).toFixed(2)}
                                  </td> */}
                                  <td>
                                    {camp.notes
                                      ? capitalizeFirstLetter(camp.notes)
                                      : "-"}
                                  </td>
                                  <td
                                    style={{
                                      cursor: "pointer",
                                      color: "blue",
                                    }}
                                    onClick={() =>
                                      this.renderPlayerPaymentDetailPage(
                                        camp,
                                        "active"
                                      )
                                    }
                                  >
                                    View
                                  </td>
                                  <td>
                                    {/* {camp.notes && */}
                                    {/* camp.notes === "payment done by admin" ? ( */}
                                    <FiMinusCircle
                                      size="20px"
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.toggleRemoveEventModel(camp)
                                      }
                                    ></FiMinusCircle>
                                    {/* ) : ( */}
                                    {/* "-" */}
                                    {/* )} */}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="12" className="text-center">
                                  No events found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </TabPanel>
                      <TabPanel>
                        <Table striped hover responsive>
                          <thead>
                            <tr>
                              <th>Event Name</th>
                              <th>State</th>
                              <th>Registration</th>
                              <th>Payment Status</th>
                              <th>Price</th>
                              {/* <th>Pending Price</th>
                              <th>Credit Amount</th> */}
                              <th>Notes</th>
                              <th>View Transaction</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.expiredCamps.length > 0 ? (
                              this.state.expiredCamps.map((camp, index) => (
                                <tr key={index}>
                                  <td>
                                    {capitalizeFirstLetter(camp.campName)}
                                  </td>
                                  <td>
                                    <BsCircleFill></BsCircleFill>
                                  </td>
                                  <td>
                                    {moment.utc(camp.createdAt).format("LL")}
                                  </td>
                                  <td>
                                    {capitalizeFirstLetter(camp.paymentStatus)}
                                  </td>
                                  <td>{camp.price.toFixed(2)}</td>
                                  {/* <td>{camp.pendingPrice.toFixed(2)}</td>
                                  <td>
                                    {camp.creditAmount
                                      ? camp.creditAmount.toFixed(2)
                                      : (0).toFixed(2)}
                                  </td> */}
                                  <td>
                                    {camp.notes
                                      ? capitalizeFirstLetter(camp.notes)
                                      : "-"}
                                  </td>
                                  <td
                                    style={{
                                      cursor: "pointer",
                                      color: "blue",
                                    }}
                                    onClick={() =>
                                      this.renderPlayerPaymentDetailPage(
                                        camp,
                                        "inactive"
                                      )
                                    }
                                  >
                                    View
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="12" className="text-center">
                                  No events found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </TabPanel>
                      {/* <TabPanel>
                        <Table striped hover responsive>
                          <thead>
                            <tr>
                              <th>Amount</th>
                              <th>Note</th>
                              <th>Date</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.creditHistory.length > 0 ? (
                              this.state.creditHistory.map((history, index) => (
                                <tr key={index}>
                                  <td>
                                    {history.creditAmount.toFixed(2) || "0"}
                                  </td>
                                  <td>{history.note || "-"}</td>
                                  <td>
                                    {moment
                                      .utc(history.createdAt)
                                      .format("MM-DD-YYYY") || "-"}
                                  </td>
                                  <td>
                                    {history.status
                                      ? capitalizeFirstLetter(history.status)
                                      : "-"}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="12" className="text-center">
                                  No credit history found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </TabPanel>
                      <TabPanel>
                        <Table striped hover responsive>
                          <thead>
                            <tr>
                              <th>Amount</th>
                              <th>Note</th>
                              <th>Date</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.dueHistory.length > 0 ? (
                              this.state.dueHistory.map((history, index) => (
                                <tr key={index}>
                                  <td>{history.dueAmount.toFixed(2) || "0"}</td>
                                  <td>{history.note || "-"}</td>
                                  <td>
                                    {moment
                                      .utc(history.createdAt)
                                      .format("MM-DD-YYYY") || "-"}
                                  </td>
                                  <td>
                                    {history.status
                                      ? capitalizeFirstLetter(history.status)
                                      : "-"}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="12" className="text-center">
                                  No due history found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </TabPanel> */}
                      <TabPanel>
                        <Table striped hover responsive>
                          <thead>
                            <tr>
                              <th style={{ width: "50%", textAlign: "center" }}>
                                Payment Balance
                              </th>
                              <th>
                                $
                                {this.state.paymentBalance
                                  ? this.state.paymentBalance.toFixed(2)
                                  : "0"}
                              </th>
                            </tr>
                          </thead>
                        </Table>
                        <Table striped hover responsive>
                          <thead>
                            <tr>
                              <th>Amount</th>
                              <th>
                                Note
                                <BsFillQuestionCircleFill
                                  size="15px"
                                  id="noteTooltip"
                                  style={{
                                    margin: "auto auto auto 5px",
                                    outline: " unset",
                                    cursor: "pointer",
                                  }}
                                  onMouseOver={() =>
                                    this.setState({
                                      noteTooltip: true,
                                    })
                                  }
                                  onMouseOut={() =>
                                    this.setState({
                                      noteTooltip: false,
                                    })
                                  }
                                />
                                <Tooltip
                                  placement={
                                    this.state.paymentBalanceBreakUp.length
                                      ? "bottom"
                                      : "right"
                                  }
                                  isOpen={this.state.noteTooltip}
                                  target="noteTooltip"
                                  toggle={() => {}}
                                >
                                  Double click on note text to edit the note
                                </Tooltip>
                              </th>
                              <th>Date</th>
                              <th>
                                Status
                                <BsFillQuestionCircleFill
                                  size="15px"
                                  id="statusTooltip"
                                  style={{
                                    margin: "auto auto auto 5px",
                                    outline: " unset",
                                    cursor: "pointer",
                                  }}
                                  onMouseOver={() =>
                                    this.setState({
                                      statusTooltip: true,
                                    })
                                  }
                                  onMouseOut={() =>
                                    this.setState({
                                      statusTooltip: false,
                                    })
                                  }
                                />
                                <Tooltip
                                  placement={
                                    this.state.paymentBalanceBreakUp.length
                                      ? "bottom"
                                      : "right"
                                  }
                                  isOpen={this.state.statusTooltip}
                                  target="statusTooltip"
                                  toggle={() => {}}
                                >
                                  Credit - Amount credited in payment balance.
                                  <br />
                                  Debit - Amount debited from payment balance.
                                </Tooltip>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.paymentBalanceBreakUp.length > 0 ? (
                              this.state.paymentBalanceBreakUp.map(
                                (history, index) => (
                                  <tr key={index}>
                                    <td>
                                      {history.status === "pending" ? (
                                        <span
                                          style={{
                                            marginRight: "5px",
                                          }}
                                        >
                                          ?
                                        </span>
                                      ) : history.status === "credit" ? (
                                        <span
                                          style={{
                                            color: "#26ab2b",
                                            marginRight: "5px",
                                          }}
                                        >
                                          +
                                        </span>
                                      ) : (
                                        <span
                                          style={{
                                            color: "red",
                                            fontSize: "20px",
                                            marginRight: "5px",
                                          }}
                                        >
                                          -
                                        </span>
                                      )}
                                      {history.amount.toFixed(2) || "0"}
                                    </td>
                                    <td>
                                      <div className="d-flex">
                                        {this.state
                                          .selectedIndexForPaymentBalance ===
                                        index ? (
                                          <div className="d-flex">
                                            <Input
                                              type="text"
                                              value={this.state.note}
                                              onChange={(event) =>
                                                this.setState({
                                                  note: event.target.value,
                                                })
                                              }
                                            ></Input>
                                            <BsCheck
                                              onClick={() => {
                                                this.updatePlayerPaymentBalanceNote(
                                                  history._id
                                                );
                                              }}
                                              className="ml-2"
                                              style={{
                                                cursor: "pointer",
                                                margin: "auto 0px",
                                              }}
                                              size="30px"
                                            ></BsCheck>
                                            <MdClose
                                              onClick={() => {
                                                this.setState({
                                                  selectedIndexForPaymentBalance: null,
                                                  note: history.note,
                                                });
                                              }}
                                              className="ml-3 "
                                              style={{
                                                cursor: "pointer",
                                                margin: "auto 0px",
                                              }}
                                              size="30px"
                                            ></MdClose>
                                          </div>
                                        ) : (
                                          <div
                                            onDoubleClick={() => {
                                              this.setState({
                                                selectedIndexForPaymentBalance: index,
                                                note: history.note,
                                              });
                                            }}
                                          >
                                            {history.note || "-"}
                                          </div>
                                        )}
                                      </div>
                                    </td>
                                    <td>
                                      {moment
                                        .utc(history.createdAt)
                                        .format("MM-DD-YYYY") || "-"}
                                    </td>
                                    <td>
                                      {history.status
                                        ? capitalizeFirstLetter(history.status)
                                        : "-"}
                                    </td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr>
                                <td
                                  // style={{ height: "2000px" }}
                                  colSpan="4"
                                  className="text-center"
                                >
                                  No payment balance history found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </TabPanel>
                    </Tabs>
                  </Row>
                </CardBody>
                {this.state.creditAmountModel ? (
                  <Modal
                    isOpen={this.state.creditAmountModel}
                    toggle={(event) => this.toggleCreditModel(event)}
                    className="modal-md"
                  >
                    <ModalHeader
                      toggle={(event) => this.toggleCreditModel(event)}
                    >
                      <Label>
                        {this.state.action === "add"
                          ? "Add Credit"
                          : "Remove Credit"}
                      </Label>
                    </ModalHeader>
                    <Form onSubmit={(event) => this.CreditAmount(event)}>
                      <ModalBody>
                        <Row>
                          <Col xl={12} lg={12} md={12}>
                            <FormGroup>
                              <Label>Amount</Label>
                              <Input
                                type="number"
                                placeholder={
                                  this.state.action === "add"
                                    ? "Enter Amount"
                                    : "Enter Amount Less Than Credit Balance"
                                }
                                value={this.state.creditAmount}
                                onChange={(event) =>
                                  event.target.value >= 0
                                    ? this.state.action === "remove"
                                      ? event.target.value <=
                                          this.state.child.creditAmount &&
                                        this.setState({
                                          creditAmount: event.target.value,
                                        })
                                      : this.setState({
                                          creditAmount: event.target.value,
                                        })
                                    : ""
                                }
                                required
                              ></Input>
                            </FormGroup>
                          </Col>
                          <Col xl={12} lg={12} md={12}>
                            <FormGroup>
                              <Label>Add Note</Label>
                              <Input
                                required
                                type="text"
                                placeholder="Add Note"
                                value={this.state.notes}
                                onChange={(event) =>
                                  this.setState({
                                    notes: event.target.value,
                                  })
                                }
                              ></Input>
                            </FormGroup>
                          </Col>
                          <Col xl={12} lg={12} md={12}>
                            <FormGroup>
                              <Label>Select Event</Label>
                              <Select
                                isSearchable={false}
                                placeholder="Select the event"
                                value={this.state.selectedCampForCreditAmount}
                                options={this.state.campsOptions}
                                onChange={(result) =>
                                  this.setState({
                                    selectedCampForCreditAmount: result,
                                  })
                                }
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </ModalBody>
                      <ModalFooter>
                        <Button type="submit">Submit</Button>
                        <Button
                          color="secondary"
                          onClick={(event) => this.toggleCreditModel(event)}
                        >
                          Cancel
                        </Button>
                      </ModalFooter>
                    </Form>
                  </Modal>
                ) : null}
                {this.state.ImageModel && (
                  <Lightbox
                    mainSrc={this.state.imageUrl}
                    onCloseRequest={() => this.setState({ ImageModel: false })}
                  />
                )}
                {this.state.changeStatusConfirmationModal ? (
                  <Modal
                    isOpen={this.state.changeStatusConfirmationModal}
                    toggle={(event) =>
                      this.togglechangeStatusConfirmationModal(event)
                    }
                    className="modal-md"
                  >
                    <ModalHeader
                      toggle={(event) =>
                        this.togglechangeStatusConfirmationModal(event)
                      }
                    ></ModalHeader>
                    <ModalBody>
                      Are you sure you want to change status ?
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        color="primary"
                        onClick={(event) => {
                          this.updateImageStatus(event);
                          this.togglechangeStatusConfirmationModal(event);
                        }}
                      >
                        {this.state.status === "accepted" ? "Accept" : "Reject"}
                      </Button>
                      <Button
                        color="secondary"
                        onClick={(event) =>
                          this.togglechangeStatusConfirmationModal(event)
                        }
                      >
                        Cancel
                      </Button>
                    </ModalFooter>
                  </Modal>
                ) : null}
                {this.state.dueAmountModel ? (
                  <Modal
                    isOpen={this.state.dueAmountModel}
                    toggle={(event) => this.toggleDueModel(event)}
                    className="modal-md"
                  >
                    <ModalHeader toggle={(event) => this.toggleDueModel(event)}>
                      <Label>
                        {this.state.dueAction === "add"
                          ? "Add Past Due"
                          : "Remove Past Due"}
                      </Label>
                    </ModalHeader>
                    <Form onSubmit={(event) => this.dueAmount(event)}>
                      <ModalBody>
                        <Row>
                          <Col xl={12} lg={12} md={12}>
                            <FormGroup>
                              <Label>Amount :-</Label>
                              <Input
                                type="number"
                                placeholder={
                                  this.state.dueAction === "add"
                                    ? "Enter Past Due Amount"
                                    : "Enter Amount Less Than Past Due"
                                }
                                value={this.state.dueAmount}
                                onChange={(event) =>
                                  event.target.value >= 0
                                    ? this.state.dueAction === "remove"
                                      ? event.target.value <=
                                          this.state.child.dueAmount &&
                                        this.setState({
                                          dueAmount: event.target.value,
                                        })
                                      : this.setState({
                                          dueAmount: event.target.value,
                                        })
                                    : ""
                                }
                                required
                              ></Input>
                            </FormGroup>
                          </Col>
                          <Col xl={12} lg={12} md={12}>
                            <FormGroup>
                              <Label>Add Note :-</Label>
                              <Input
                                required
                                type="text"
                                placeholder="Add Note"
                                value={this.state.dueNote}
                                onChange={(event) =>
                                  this.setState({
                                    dueNote: event.target.value,
                                  })
                                }
                              ></Input>
                            </FormGroup>
                          </Col>
                          <Col xl={12} lg={12} md={12}>
                            <FormGroup>
                              <Label>Select Event</Label>
                              <Select
                                isSearchable={false}
                                placeholder="Select the event"
                                value={this.state.selectedCampForDueAmount}
                                options={this.state.campsOptions}
                                onChange={(result) =>
                                  this.setState({
                                    selectedCampForDueAmount: result,
                                  })
                                }
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </ModalBody>
                      <ModalFooter>
                        <Button type="submit">Submit</Button>
                        <Button
                          color="secondary"
                          onClick={(event) => this.toggleDueModel(event)}
                        >
                          Cancel
                        </Button>
                      </ModalFooter>
                    </Form>
                  </Modal>
                ) : null}
                {this.state.removePlayerModal ? (
                  <Modal
                    isOpen={this.state.removePlayerModal}
                    toggle={(event) => this.toggleRemovePlayerModal()}
                    className="modal-md"
                  >
                    <ModalHeader
                      toggle={(event) => this.toggleRemovePlayerModal()}
                    >
                      Delete Player
                    </ModalHeader>
                    <ModalBody>
                      Are you sure you want to delete{" "}
                      {this.state.child.data.firstName +
                        " " +
                        this.state.child.data.lastName}{" "}
                      ?
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        color="secondary"
                        onClick={(event) => this.toggleRemovePlayerModal()}
                      >
                        Cancel
                      </Button>
                      <Button
                        color="primary"
                        onClick={(event) => {
                          this.removePlayer();
                          this.toggleRemovePlayerModal();
                        }}
                      >
                        Delete
                      </Button>
                    </ModalFooter>
                  </Modal>
                ) : null}
                {this.state.archivePlayerModal ? (
                  <Modal
                    isOpen={this.state.archivePlayerModal}
                    toggle={(event) => this.toggleArchivePlayerModal()}
                    className="modal-md"
                  >
                    <ModalHeader
                      toggle={(event) => this.toggleArchivePlayerModal()}
                    >
                      {this.state.child.isArchived
                        ? "Unarchive Player"
                        : "Archive Player"}
                    </ModalHeader>
                    <ModalBody>
                      Are you sure you want to{" "}
                      {this.state.child.isArchived ? "unarchive" : "archive"}{" "}
                      {this.state.child.data.firstName +
                        " " +
                        this.state.child.data.lastName}{" "}
                      ?
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        color="secondary"
                        onClick={(event) => this.toggleArchivePlayerModal()}
                      >
                        Cancel
                      </Button>
                      <Button
                        color="primary"
                        onClick={(event) => {
                          {
                            this.state.child.isArchived
                              ? this.unarchivePlayer()
                              : this.archivePlayer();
                          }
                          this.toggleArchivePlayerModal();
                        }}
                      >
                        {this.state.child.isArchived ? "Unarchive" : "Archive"}
                      </Button>
                    </ModalFooter>
                  </Modal>
                ) : null}
                {this.state.dueAmountBreakUpModal ? (
                  <Modal
                    isOpen={this.state.dueAmountBreakUpModal}
                    toggle={(event) => this.toggleDueAmountBreakUpModal()}
                    className="modal-lg"
                  >
                    <ModalHeader
                      toggle={(event) => this.toggleDueAmountBreakUpModal()}
                    >
                      Past Due Amount Break Up
                    </ModalHeader>
                    <ModalBody>
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Amount</th>
                            <th>Note</th>
                            <th>Event Name</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.child.dueAmountBreakUp &&
                          this.state.child.dueAmountBreakUp.length ? (
                            this.state.child.dueAmountBreakUp.map(
                              (value, index) =>
                                this.state.selectedIndex === index ? (
                                  <tr key={index}>
                                    <td>
                                      <Input
                                        type="Number"
                                        value={this.state.breakUpAmount}
                                        onChange={(event) => {
                                          event.persist();
                                          this.setState({
                                            breakUpAmount: event.target.value,
                                          });
                                        }}
                                      ></Input>
                                    </td>
                                    <td>
                                      <Input
                                        type="text"
                                        value={this.state.breakUpNote}
                                        onChange={(event) => {
                                          event.persist();
                                          this.setState({
                                            breakUpNote: event.target.value,
                                          });
                                        }}
                                      ></Input>
                                    </td>
                                    <td style={{ width: "30%" }}>
                                      <Select
                                        isSearchable={true}
                                        isClearable={true}
                                        placeholder="Select the event"
                                        value={
                                          this.state.selectedCampForDueAmount
                                        }
                                        options={this.state.campsOptions}
                                        onChange={(result) =>
                                          this.setState({
                                            selectedCampForDueAmount: result,
                                          })
                                        }
                                      />
                                    </td>
                                    <td>Pending</td>
                                    <td>
                                      <BsCheck
                                        size="20px"
                                        className="mr-1"
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.updateDueAmountBreakUpValue(
                                            value
                                          )
                                        }
                                      ></BsCheck>
                                      <MdClose
                                        size="20px"
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.setState({
                                            selectedIndex: null,
                                          })
                                        }
                                      ></MdClose>
                                    </td>
                                  </tr>
                                ) : (
                                  <tr key={index}>
                                    <td>{value.amount.toFixed(2)}</td>
                                    <td>{value.note}</td>
                                    <td>
                                      {value.campName
                                        ? capitalizeFirstLetter(value.campName)
                                        : "-"}
                                    </td>
                                    <td>Pending</td>
                                    <td>
                                      <MdEdit
                                        size="20px"
                                        className="mr-1"
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.setState({
                                            breakUpNote: value.note,
                                            breakUpAmount: value.amount,
                                            previousBreakUpAmount: value.amount,
                                            selectedIndex: index,
                                            selectedCampForDueAmount: {
                                              label: value.campName,
                                              value: value.campId,
                                            },
                                          })
                                        }
                                      ></MdEdit>
                                      <MdDeleteForever
                                        size="20px"
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.deleteDueAmountBreakUpValue(
                                            value
                                          )
                                        }
                                      ></MdDeleteForever>
                                    </td>
                                  </tr>
                                )
                            )
                          ) : (
                            <tr>
                              <td
                                colSpan="5"
                                className="text-center"
                                style={{ background: "#dee2e6" }}
                              >
                                All past due amount processed
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </ModalBody>
                  </Modal>
                ) : null}
                {this.state.creditAmountBreakUpModal ? (
                  <Modal
                    isOpen={this.state.creditAmountBreakUpModal}
                    toggle={(event) => this.toggleCreditAmountBreakUpModal()}
                    className="modal-lg"
                  >
                    <ModalHeader
                      toggle={(event) => this.toggleCreditAmountBreakUpModal()}
                    >
                      Credit Amount Break Up
                    </ModalHeader>
                    <ModalBody>
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Amount</th>
                            <th>Note</th>
                            <th>Event Name</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.child.creditAmountBreakUp &&
                          this.state.child.creditAmountBreakUp.length ? (
                            this.state.child.creditAmountBreakUp.map(
                              (value, index) =>
                                this.state.selectedCreditIndex === index ? (
                                  <tr key={index}>
                                    <td>
                                      <Input
                                        type="Number"
                                        value={this.state.creditBreakUpAmount}
                                        onChange={(event) => {
                                          event.persist();
                                          this.setState({
                                            creditBreakUpAmount:
                                              event.target.value,
                                          });
                                        }}
                                      ></Input>
                                    </td>
                                    <td>
                                      <Input
                                        type="text"
                                        value={this.state.creditBreakUpNote}
                                        onChange={(event) => {
                                          event.persist();
                                          this.setState({
                                            creditBreakUpNote:
                                              event.target.value,
                                          });
                                        }}
                                      ></Input>
                                    </td>
                                    <td style={{ width: "30%" }}>
                                      <Select
                                        isSearchable={true}
                                        isClearable={true}
                                        placeholder="Select the event"
                                        value={
                                          this.state.selectedCampForCreditAmount
                                        }
                                        options={this.state.campsOptions}
                                        onChange={(result) =>
                                          this.setState({
                                            selectedCampForCreditAmount: result,
                                          })
                                        }
                                      />
                                    </td>
                                    <td>Pending</td>
                                    <td>
                                      <BsCheck
                                        size="20px"
                                        className="mr-1"
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.updateCreditAmountBreakUpValue(
                                            value
                                          )
                                        }
                                      ></BsCheck>
                                      <MdClose
                                        size="20px"
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.setState({
                                            selectedCreditIndex: null,
                                          })
                                        }
                                      ></MdClose>
                                    </td>
                                  </tr>
                                ) : (
                                  <tr key={index}>
                                    <td>{value.amount.toFixed(2)}</td>
                                    <td>{value.note}</td>
                                    <td>
                                      {value.campName
                                        ? capitalizeFirstLetter(value.campName)
                                        : "-"}
                                    </td>
                                    <td>Pending</td>
                                    <td>
                                      <MdEdit
                                        size="20px"
                                        className="mr-1"
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.setState({
                                            creditBreakUpNote: value.note,
                                            creditBreakUpAmount: value.amount,
                                            previousCreditBreakUpAmount:
                                              value.amount,
                                            selectedCreditIndex: index,
                                            selectedCampForCreditAmount: {
                                              label: value.campName,
                                              value: value.campId,
                                            },
                                          })
                                        }
                                      ></MdEdit>
                                      <MdDeleteForever
                                        size="20px"
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.deleteCreditAmountBreakUpValue(
                                            value
                                          )
                                        }
                                      ></MdDeleteForever>
                                    </td>
                                  </tr>
                                )
                            )
                          ) : (
                            <tr>
                              <td
                                colSpan="5"
                                className="text-center"
                                style={{ background: "#dee2e6" }}
                              >
                                All credit amount processed
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </ModalBody>
                  </Modal>
                ) : null}
                {this.state.selectTeamConfirmationModal ? (
                  <Modal
                    isOpen={this.state.selectTeamConfirmationModal}
                    toggle={(event) =>
                      this.toggleSelectTeamPlayerConfirmationModal(event)
                    }
                    className="modal-md"
                  >
                    <ModalHeader
                      toggle={(event) =>
                        this.toggleSelectTeamPlayerConfirmationModal(event)
                      }
                    >
                      <Label>Select Primary Team :</Label>
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col xl={12} lg={12} md={12}>
                          <Label>Select Team :</Label>
                          <Select
                            className="basic-multi-select"
                            classNamePrefix="select"
                            options={this.state.allTeamsOptions}
                            value={this.state.primarySelectedTeam}
                            onChange={(result) =>
                              this.setState({
                                primarySelectedTeam: result,
                              })
                            }
                          />
                        </Col>
                      </Row>
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        onClick={(event) => {
                          this.updatePrimaryTeamId(event);
                          this.toggleSelectTeamPlayerConfirmationModal(event);
                        }}
                      >
                        Select Team
                      </Button>
                      <Button
                        color="secondary"
                        onClick={(event) =>
                          this.toggleSelectTeamPlayerConfirmationModal(event)
                        }
                      >
                        Cancel
                      </Button>
                    </ModalFooter>
                  </Modal>
                ) : null}
                {this.state.addTeamConfirmationModal ? (
                  <Modal
                    isOpen={this.state.addTeamConfirmationModal}
                    toggle={(event) =>
                      this.toggleAddTeamPlayerConfirmationModal(event)
                    }
                    className="modal-md"
                  >
                    <ModalHeader
                      toggle={(event) =>
                        this.toggleAddTeamPlayerConfirmationModal(event)
                      }
                    >
                      <Label>Add To Teams :</Label>
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col xl={12} lg={12} md={12}>
                          <Label>Select Team :</Label>
                          <Select
                            isMulti
                            closeMenuOnSelect={false}
                            options={this.state.teamOptions}
                            value={this.state.selectedTeams}
                            onChange={this.handleTeamChange}
                            className="basic-multi-select"
                            classNamePrefix="select"
                          />
                        </Col>
                      </Row>
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        onClick={(event) => {
                          this.updateTeams(event);
                          this.toggleAddTeamPlayerConfirmationModal(event);
                        }}
                      >
                        Add
                      </Button>
                      <Button
                        color="secondary"
                        onClick={(event) =>
                          this.toggleAddTeamPlayerConfirmationModal(event)
                        }
                      >
                        Cancel
                      </Button>
                    </ModalFooter>
                  </Modal>
                ) : null}
                {this.state.removeTeamModel ? (
                  <Modal
                    isOpen={this.state.removeTeamModel}
                    toggle={(event) => this.toggleRemoveTeamModel(event)}
                    className="modal-md"
                  >
                    <ModalHeader
                      toggle={(event) => this.toggleRemoveTeamModel(event)}
                    >
                      Remove Team :
                    </ModalHeader>
                    <ModalBody>
                      Are you sure you want to remove{" "}
                      {this.state.child.data.firstName} from{" "}
                      {this.state.selectedTeam.name}?
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        color="secondary"
                        onClick={(event) => this.toggleRemoveTeamModel(event)}
                      >
                        Cancel
                      </Button>
                      <Button
                        color="primary"
                        onClick={(event) => {
                          this.removeTeam(event);
                          this.toggleRemoveTeamModel(event);
                        }}
                      >
                        Remove
                      </Button>
                    </ModalFooter>
                  </Modal>
                ) : null}
                {this.state.removeEventModal ? (
                  <Modal
                    isOpen={this.state.removeEventModal}
                    toggle={(event) => this.toggleRemoveEventModel(event)}
                    className="modal-md"
                  >
                    <ModalHeader
                      toggle={(event) => this.toggleRemoveEventModel(event)}
                    >
                      Remove Event :
                    </ModalHeader>
                    <ModalBody>Are you sure you want to remove ?</ModalBody>
                    <ModalFooter>
                      <Button
                        color="secondary"
                        onClick={(event) => this.toggleRemoveEventModel(event)}
                      >
                        Cancel
                      </Button>
                      <Button
                        color="primary"
                        onClick={(event) => {
                          this.removeEvent(event);
                          this.toggleRemoveEventModel(event);
                        }}
                      >
                        Remove
                      </Button>
                    </ModalFooter>
                  </Modal>
                ) : null}
                {this.state.cardViewModal ? (
                  <Modal
                    isOpen={this.state.cardViewModal}
                    toggle={(event) => this.toggleCardViewModal()}
                    className="modal-md"
                  >
                    <ModalHeader toggle={(event) => this.toggleCardViewModal()}>
                      Credit Card Details
                    </ModalHeader>
                    <ModalBody>
                      <Row
                        style={
                          this.state.addCardCollapse
                            ? {
                                borderBottom: "1px solid #dee2e6",
                                marginBottom: "10px",
                              }
                            : null
                        }
                      >
                        <Col>
                          <Button
                            id="toggler"
                            className="float-right mb-2"
                            onClick={() => {
                              this.setState({
                                addCardCollapse: !this.state.addCardCollapse,
                              });
                            }}
                          >
                            Add Credit Card
                          </Button>
                        </Col>
                      </Row>
                      <UncontrolledCollapse
                        toggler="#toggler"
                        isOpen={this.state.addCardCollapse}
                      >
                        <Form className="form" onSubmit={this.addCreditCard}>
                          <Row style={{ padding: "0px 15px" }}>
                            <Col style={{ margin: "auto" }}>
                              <Cards
                                cvc={this.state.cvc}
                                expiry={this.state.expiry}
                                focused={this.state.focus}
                                name={this.state.name}
                                number={this.state.number}
                                callback={(event) => {
                                  this.setState({ cardType: event.issuer });
                                }}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col className="mt-3">
                              <Label>Select Adult</Label>
                              <Select
                                placeholder="Select the Adult"
                                value={this.state.selectedAdult}
                                options={this.state.allAdultsOptions}
                                onChange={(result) =>
                                  this.setState({
                                    selectedAdult: result,
                                  })
                                }
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col className="mt-3">
                              <>
                                <Label>Card Number</Label>
                                <FormGroup>
                                  <Input
                                    id="number"
                                    name="number"
                                    type="text"
                                    maxLength="16"
                                    value={this.state.number}
                                    onChange={(event) =>
                                      this.setState({
                                        number: event.target.value,
                                        focus: "number",
                                      })
                                    }
                                    placeholder="CARD NUMBER"
                                    required
                                  />
                                </FormGroup>
                              </>
                              <>
                                <Label>Card Name</Label>
                                <FormGroup>
                                  <Input
                                    id="name"
                                    name="name"
                                    type="text"
                                    value={this.state.name}
                                    onChange={(event) =>
                                      this.setState({
                                        name: event.target.value,
                                        focus: "name",
                                      })
                                    }
                                    placeholder="CARD NAME"
                                    required
                                  />
                                </FormGroup>
                              </>
                              <Row>
                                <Col xl={6} lg={6} md={12} sm={12}>
                                  <Label>Card Expiration Date</Label>
                                  <FormGroup>
                                    <Input
                                      id="expiry"
                                      name="expiry"
                                      type="text"
                                      maxLength="4"
                                      value={this.state.expiry}
                                      onChange={(event) =>
                                        this.setState({
                                          expiry: event.target.value,
                                          focus: "expiry",
                                        })
                                      }
                                      placeholder="MM/YY"
                                      required
                                    />
                                  </FormGroup>
                                </Col>
                                <Col xl={6} lg={6} md={12} sm={12}>
                                  <Label>CVC</Label>
                                  <FormGroup>
                                    <Input
                                      id="cvc"
                                      name="cvc"
                                      type="text"
                                      maxLength="4"
                                      value={this.state.cvc}
                                      onChange={(event) =>
                                        this.setState({
                                          cvc: event.target.value,
                                          focus: "cvc",
                                        })
                                      }
                                      placeholder="CVC"
                                      required
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <>
                                <FormGroup>
                                  <Button type="submit" onClick={() => {}}>
                                    Add Credit Card
                                  </Button>
                                </FormGroup>
                              </>
                            </Col>
                          </Row>
                        </Form>
                      </UncontrolledCollapse>
                      <Table striped hover responsive>
                        <thead>
                          <tr>
                            <th className={"text-center"}>Adult Name</th>
                            <th className={"text-center"}>Card Number</th>
                            <th className={"text-center"}>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.stripeCards.length ? (
                            this.state.stripeCards.map((card, index) => (
                              <tr key={index}>
                                <td className={"text-center"}>
                                  {card.name ? card.name : "-"}
                                </td>
                                <td className={"text-center"}>
                                  {card.number ? card.number : "-"}
                                </td>
                                <td className={"text-center"}>
                                  <MdDeleteForever
                                    size="20px"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      this.toggleDeleteCardModal(
                                        card.paymentMethodId,
                                        "card"
                                      )
                                    }
                                  ></MdDeleteForever>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="3" className="text-center">
                                No cards found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </ModalBody>
                  </Modal>
                ) : null}
                {this.state.bankViewModal ? (
                  <Modal
                    isOpen={this.state.bankViewModal}
                    toggle={(event) => this.toggleBankViewModal()}
                    className="modal-md"
                  >
                    <ModalHeader toggle={(event) => this.toggleBankViewModal()}>
                      Bank Account Details
                    </ModalHeader>
                    <ModalBody>
                      <Row
                        style={
                          this.state.addBankCollapse
                            ? { borderBottom: "1px solid #dee2e6" }
                            : null
                        }
                      >
                        <Col>
                          <Button
                            id="toggler1"
                            className="float-right mb-2"
                            onClick={() => {
                              this.setState({
                                viewError: false,
                                addBankCollapse: !this.state.addBankCollapse,
                              });
                            }}
                          >
                            Add an ACH debit bank account
                          </Button>
                        </Col>
                      </Row>
                      <UncontrolledCollapse
                        toggler="#toggler1"
                        isOpen={this.state.addBankCollapse}
                      >
                        <Form className="form" onSubmit={this.addBankAccount}>
                          <Row>
                            <Col className="mt-3">
                              <Label>Select Adult</Label>
                              <Select
                                placeholder="Select the Adult"
                                value={this.state.selectedAdult}
                                options={this.state.allAdultsOptions}
                                onChange={(result) =>
                                  this.setState({
                                    selectedAdult: result,
                                  })
                                }
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col className="mt-3">
                              <>
                                <Label>Account holder name</Label>
                                <FormGroup>
                                  <Input
                                    id="account_holder_name"
                                    name="account_holder_name"
                                    type="text"
                                    value={this.state.account_holder_name}
                                    onChange={(event) =>
                                      this.setState({
                                        account_holder_name: event.target.value,
                                      })
                                    }
                                    placeholder="Account Holder Name"
                                    required
                                  />
                                </FormGroup>
                              </>
                              <>
                                <Label>Routing number</Label>
                                <FormGroup>
                                  <Input
                                    id="routing_number"
                                    name="routing_number"
                                    type="text"
                                    maxLength="9"
                                    value={this.state.routing_number}
                                    onChange={(event) =>
                                      this.setState({
                                        routing_number: event.target.value,
                                      })
                                    }
                                    placeholder="Routing Number"
                                    required
                                  />
                                </FormGroup>
                              </>
                              <>
                                <Label>Account number</Label>
                                <FormGroup>
                                  <Input
                                    id="account_number"
                                    name="account_number"
                                    type="text"
                                    maxLength="12"
                                    value={this.state.account_number}
                                    onChange={(event) =>
                                      this.setState({
                                        account_number: event.target.value,
                                      })
                                    }
                                    placeholder="Account Number"
                                    required
                                  />
                                </FormGroup>
                              </>
                              <>
                                <Label>Confirm account number</Label>
                                <FormGroup>
                                  <Input
                                    id="confirm_account_number"
                                    name="confirm_account_number"
                                    type="text"
                                    maxLength="12"
                                    style={
                                      this.state.viewError &&
                                      this.state.account_number !==
                                        this.state.confirm_account_number
                                        ? { border: "1px solid rgb(224 66 66)" }
                                        : null
                                    }
                                    value={this.state.confirm_account_number}
                                    onChange={(event) =>
                                      this.setState({
                                        viewError: true,
                                        confirm_account_number:
                                          event.target.value,
                                      })
                                    }
                                    placeholder="Confirm Account Number"
                                    required
                                  />
                                </FormGroup>
                                {this.state.viewError &&
                                this.state.account_number !==
                                  this.state.confirm_account_number ? (
                                  <Label style={{ color: "rgb(224 66 66)" }}>
                                    <BsFillExclamationTriangleFill className="mr-1"></BsFillExclamationTriangleFill>
                                    Your account numbers don't match.
                                  </Label>
                                ) : null}
                              </>
                              <>
                                <FormGroup>
                                  <Button type="submit" onClick={() => {}}>
                                    Add ACH debit bank account
                                  </Button>
                                </FormGroup>
                              </>
                            </Col>
                          </Row>
                        </Form>
                      </UncontrolledCollapse>
                      <Table striped hover responsive>
                        <thead>
                          <tr>
                            <th className={"text-center"}>Adult Name</th>
                            <th className={"text-center"}>Name</th>
                            <th className={"text-center"}>Routing Number</th>
                            <th className={"text-center"}>Account Number</th>
                            <th className={"text-center"}>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.bankAccounts.length ? (
                            this.state.bankAccounts.map(
                              (bankAccount, index) => (
                                <tr key={index}>
                                  <td className={"text-center"}>
                                    {bankAccount.name ? bankAccount.name : "-"}
                                  </td>
                                  <td className={"text-center"}>
                                    {bankAccount.account_holder_name
                                      ? bankAccount.account_holder_name
                                      : "-"}
                                  </td>
                                  <td className={"text-center"}>
                                    {bankAccount.routing_number
                                      ? bankAccount.routing_number
                                      : "-"}
                                  </td>
                                  <td className={"text-center"}>
                                    {bankAccount.account_number
                                      ? bankAccount.account_number
                                      : "-"}
                                  </td>
                                  <td className={"text-center"}>
                                    <MdDeleteForever
                                      size="20px"
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.toggleDeleteBankModal(
                                          bankAccount.paymentMethodId,
                                          "bank_account"
                                        )
                                      }
                                    ></MdDeleteForever>
                                  </td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td colSpan="5" className="text-center">
                                No bank accounts found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </ModalBody>
                  </Modal>
                ) : null}
                {this.state.deleteCardModal ? (
                  <Modal
                    isOpen={this.state.deleteCardModal}
                    toggle={() => this.toggleDeleteCardModal()}
                    className="modal-md"
                  >
                    <ModalHeader toggle={() => this.toggleDeleteCardModal()}>
                      Delete Credit Card :
                    </ModalHeader>
                    <ModalBody>
                      Are you sure you want to delete credit card ?
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        color="secondary"
                        onClick={(event) => this.toggleDeleteCardModal()}
                      >
                        Cancel
                      </Button>
                      <Button
                        color="primary"
                        onClick={() => {
                          this.deletePaymentMethod();
                          this.toggleDeleteCardModal();
                          this.toggleCardViewModal();
                        }}
                      >
                        Delete
                      </Button>
                    </ModalFooter>
                  </Modal>
                ) : null}
                {this.state.deleteBankModal ? (
                  <Modal
                    isOpen={this.state.deleteBankModal}
                    toggle={(event) => this.toggleDeleteBankModal()}
                    className="modal-md"
                  >
                    <ModalHeader toggle={() => this.toggleDeleteBankModal()}>
                      Delete Bank Account :
                    </ModalHeader>
                    <ModalBody>
                      Are you sure you want to delete bank account ?
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        color="secondary"
                        onClick={() => this.toggleDeleteBankModal()}
                      >
                        Cancel
                      </Button>
                      <Button
                        color="primary"
                        onClick={() => {
                          this.deletePaymentMethod();
                          this.toggleDeleteBankModal();
                          this.toggleBankViewModal();
                        }}
                      >
                        Delete
                      </Button>
                    </ModalFooter>
                  </Modal>
                ) : null}
                {this.state.registerParentModal ? (
                  <Modal
                    isOpen={this.state.registerParentModal}
                    toggle={(event) => this.toggleRegisterParentModal()}
                    className="modal-md"
                  >
                    <ModalHeader
                      toggle={() => this.toggleRegisterParentModal()}
                    >
                      Register Adult :
                    </ModalHeader>
                    <ModalBody>
                      <Form className="form" onSubmit={this.onSubmit}>
                        {this.state.registerFormFieldsAdult.map(
                          (registerFormField, index) => (
                            <Col key={index}>
                              <FormGroup>
                                {registerFormField.inputType === "text" && (
                                  <>
                                    <Label>
                                      {registerFormField.placeholder}
                                      {registerFormField.required && (
                                        <span
                                          style={{
                                            color: "red",
                                            marginLeft: "5px",
                                          }}
                                        >
                                          *
                                        </span>
                                      )}
                                    </Label>
                                    <div style={{ display: "flex" }}>
                                      <Input
                                        id={index}
                                        name={registerFormField.name}
                                        type="text"
                                        value={
                                          this.state.adult[
                                            registerFormField.keyName
                                          ] || ""
                                        }
                                        onChange={(event) =>
                                          this.updateState(
                                            "adult",
                                            registerFormField.keyName,
                                            event.target.value
                                          )
                                        }
                                        placeholder={
                                          registerFormField.placeholder
                                        }
                                        required={registerFormField.required}
                                      />
                                    </div>
                                  </>
                                )}
                                {registerFormField.inputType === "number" && (
                                  <>
                                    <Label>
                                      {registerFormField.placeholder}
                                      {registerFormField.required && (
                                        <span
                                          style={{
                                            color: "red",
                                            marginLeft: "5px",
                                          }}
                                        >
                                          *
                                        </span>
                                      )}
                                    </Label>
                                    <div style={{ display: "flex" }}>
                                      <Input
                                        id={index}
                                        name={registerFormField.name}
                                        type="number"
                                        value={
                                          this.state.adult[
                                            registerFormField.keyName
                                          ] || ""
                                        }
                                        onChange={(event) =>
                                          event.target.value > -1 &&
                                          this.updateState(
                                            "adult",
                                            registerFormField.keyName,
                                            event.target.value
                                          )
                                        }
                                        placeholder={
                                          registerFormField.placeholder
                                        }
                                        required={registerFormField.required}
                                      />
                                    </div>
                                  </>
                                )}
                                {registerFormField.inputType ===
                                  "datepicker" && (
                                  <>
                                    <Label>
                                      {registerFormField.placeholder}
                                      {registerFormField.required && (
                                        <span
                                          style={{
                                            color: "red",
                                            marginLeft: "5px",
                                          }}
                                        >
                                          *
                                        </span>
                                      )}
                                    </Label>
                                    <Input
                                      id={index}
                                      name={registerFormField.name}
                                      type="date"
                                      value={
                                        this.state.adult[
                                          registerFormField.keyName
                                        ] || ""
                                      }
                                      onChange={(event) =>
                                        this.updateState(
                                          "adult",
                                          registerFormField.keyName,
                                          event.target.value
                                        )
                                      }
                                      placeholder={
                                        registerFormField.placeholder
                                      }
                                      required={registerFormField.required}
                                    />
                                  </>
                                )}
                                {registerFormField.inputType === "dropdown" && (
                                  <>
                                    <Label>
                                      {registerFormField.placeholder}
                                      {registerFormField.required && (
                                        <span
                                          style={{
                                            color: "red",
                                            marginLeft: "5px",
                                          }}
                                        >
                                          *
                                        </span>
                                      )}
                                    </Label>
                                    <Input
                                      type="select"
                                      name={registerFormField.name}
                                      value={
                                        this.state.adult[
                                          registerFormField.keyName
                                        ] || "default"
                                      }
                                      required={registerFormField.required}
                                      onChange={(event) =>
                                        this.updateState(
                                          "adult",
                                          registerFormField.keyName,
                                          event.target.value
                                        )
                                      }
                                    >
                                      <option value="default" disabled>
                                        Select the value
                                      </option>
                                      {registerFormField.values.map(
                                        (value, index) => (
                                          <option key={index} value={value}>
                                            {value}
                                          </option>
                                        )
                                      )}
                                    </Input>
                                  </>
                                )}
                                {registerFormField.inputType ===
                                  "fileupload" && (
                                  <>
                                    <Label>
                                      {registerFormField.placeholder}
                                      {registerFormField.required && (
                                        <span
                                          style={{
                                            color: "red",
                                            marginLeft: "5px",
                                          }}
                                        >
                                          *
                                        </span>
                                      )}
                                    </Label>
                                    <div>
                                      <Label htmlFor={registerFormField._id}>
                                        <span className="btn btn-secondary">
                                          Select File
                                        </span>
                                        <span style={{ marginLeft: "5px" }}>
                                          {
                                            this.state.adult[
                                              `${registerFormField.keyName}FileName`
                                            ]
                                          }
                                        </span>
                                      </Label>
                                      <input
                                        style={{ display: "none" }}
                                        id={registerFormField._id}
                                        type="file"
                                        onChange={(event) =>
                                          this.handleChange(
                                            "adult",
                                            registerFormField.keyName,
                                            event
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                )}
                              </FormGroup>
                            </Col>
                          )
                        )}
                        {this.state.wavierFormFieldsAdult.length ? (
                          <>
                            <Col
                              style={{
                                textAlign: "center",
                                padding: "10px 0px",
                                borderTop: "3px solid #e4e5e6",
                              }}
                            >
                              <h3>Waviers For Adult</h3>
                            </Col>
                            {this.state.wavierFormFieldsAdult.map(
                              (wavierFormField, index) => (
                                <Col key={index}>
                                  <FormGroup>
                                    {wavierFormField.inputType ===
                                      "waviers" && (
                                      <>
                                        <div className="d-flex">
                                          <CustomInput
                                            type="checkbox"
                                            id={wavierFormField._id}
                                            label={wavierFormField.placeholder}
                                            required={wavierFormField.required}
                                            checked={
                                              this.state.adult[
                                                wavierFormField.keyName
                                              ] || false
                                            }
                                            onChange={(event) =>
                                              this.updateState(
                                                "adult",
                                                wavierFormField.keyName,
                                                event.target.value
                                              )
                                            }
                                          />
                                          {wavierFormField.required && (
                                            <span
                                              style={{
                                                color: "red",
                                                marginLeft: "5px",
                                              }}
                                            >
                                              *
                                            </span>
                                          )}
                                        </div>
                                        <Input
                                          id={index}
                                          type="textarea"
                                          disabled
                                          style={{ height: "160px" }}
                                          value={wavierFormField.value}
                                        />
                                      </>
                                    )}
                                  </FormGroup>
                                </Col>
                              )
                            )}
                          </>
                        ) : null}
                        <Col
                          style={{
                            textAlign: "end",
                            padding: "10px 0px",
                            borderTop: "3px solid #e4e5e6",
                          }}
                        >
                          <FormGroup>
                            <Button
                              className="mr-3"
                              color="secondary"
                              onClick={() => this.toggleRegisterParentModal()}
                            >
                              Cancel
                            </Button>
                            <Button
                              type="submit"
                              color="primary"
                              onClick={() => {}}
                            >
                              Save
                            </Button>
                          </FormGroup>
                        </Col>
                      </Form>
                    </ModalBody>
                    {/* <ModalFooter>
                      <Button
                        color="secondary"
                        onClick={() => this.toggleRegisterParentModal()}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        color="primary"
                        onClick={() => {
                          this.toggleRegisterParentModal();
                        }}
                      >
                        Save
                      </Button>
                    </ModalFooter> */}
                  </Modal>
                ) : null}
                {this.state.paymentConfirmationModal ? (
                  <Modal
                    isOpen={this.state.paymentConfirmationModal}
                    toggle={(event) =>
                      this.toggleCampPaymentConfirmationModal()
                    }
                    className="modal-md"
                  >
                    <ModalHeader
                      toggle={(event) =>
                        this.toggleCampPaymentConfirmationModal()
                      }
                    >
                      Payment for Event
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col xl={12} lg={12} md={12}>
                          <FormGroup>
                            <Label>Events:</Label>
                            <Select
                              options={this.state.Camps || []}
                              isSearchable={true}
                              isClearable={true}
                              value={this.state.Camp}
                              onChange={this.handleCampChange}
                              className="basic-single"
                              classNamePrefix="select"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      {this.state.Camp.value &&
                      this.state.campDetail.includeDueAmount ? (
                        <>
                          <Row>
                            <Col xl={12} lg={12} md={12}>
                              <Label>Include any past due amount:</Label>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={6} lg={6} md={6} sm={6}>
                              <FormGroup>
                                <CustomInput
                                  id="yes"
                                  type="radio"
                                  label="Yes"
                                  checked={this.state.includeDueAmount}
                                  name="includeDueAmount"
                                  onClick={() => {
                                    let totalPrice = this.state.campPrice;
                                    if (this.state.useCreditAmount)
                                      totalPrice =
                                        totalPrice - this.state.creditAmount;
                                    totalPrice =
                                      totalPrice + this.state.dueAmount;
                                    this.setState({
                                      totalPrice:
                                        totalPrice > 0 ? totalPrice : 0,
                                      includeDueAmount: true,
                                    });
                                  }}
                                />
                              </FormGroup>
                            </Col>
                            <Col xl={6} lg={6} md={6} sm={6}>
                              <FormGroup>
                                <CustomInput
                                  id="no"
                                  type="radio"
                                  label="No"
                                  checked={!this.state.includeDueAmount}
                                  name="includeDueAmount"
                                  onClick={() => {
                                    let totalPrice = this.state.campPrice;
                                    if (this.state.useCreditAmount)
                                      totalPrice =
                                        totalPrice - this.state.creditAmount;
                                    this.setState({
                                      totalPrice:
                                        totalPrice > 0 ? totalPrice : 0,
                                      includeDueAmount: false,
                                    });
                                  }}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </>
                      ) : null}
                      {this.state.Camp.value &&
                      this.state.campDetail.useCreditAmount ? (
                        <>
                          <Row>
                            <Col xl={12} lg={12} md={12}>
                              <Label>Use credit amount:</Label>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={6} lg={6} md={6} sm={6}>
                              <FormGroup>
                                <CustomInput
                                  id="yes1"
                                  type="radio"
                                  label="Yes"
                                  checked={this.state.useCreditAmount}
                                  name="useCreditAmount"
                                  onClick={() => {
                                    let totalPrice = this.state.campPrice;
                                    if (this.state.includeDueAmount)
                                      totalPrice =
                                        totalPrice + this.state.dueAmount;
                                    totalPrice =
                                      totalPrice - this.state.creditAmount;
                                    this.setState({
                                      totalPrice:
                                        totalPrice > 0 ? totalPrice : 0,
                                      useCreditAmount: true,
                                    });
                                  }}
                                />
                              </FormGroup>
                            </Col>
                            <Col xl={6} lg={6} md={6} sm={6}>
                              <FormGroup>
                                <CustomInput
                                  id="no1"
                                  type="radio"
                                  label="No"
                                  checked={!this.state.useCreditAmount}
                                  name="useCreditAmount"
                                  onClick={() => {
                                    let totalPrice = this.state.campPrice;
                                    if (this.state.includeDueAmount)
                                      totalPrice =
                                        totalPrice + this.state.dueAmount;
                                    this.setState({
                                      totalPrice:
                                        totalPrice > 0 ? totalPrice : 0,
                                      useCreditAmount: false,
                                    });
                                  }}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </>
                      ) : null}
                      <Row>
                        <Col xl={12} lg={12} md={12}>
                          <FormGroup>
                            <Label>Event Price</Label>
                            <Input
                              disabled
                              type="text"
                              value={this.state.campPrice}
                            ></Input>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col xl={12} lg={12} md={12}>
                          <FormGroup>
                            <Label>Total Price</Label>
                            <Input
                              disabled
                              type="text"
                              value={this.state.totalPrice}
                            ></Input>
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col xl={12} lg={12} md={12}>
                          <FormGroup>
                            <Label>Add Note</Label>
                            <Input
                              required
                              type="text"
                              placeholder="Payment done by admin"
                              value={this.state.notes}
                              onChange={(event) => {
                                event.persist();
                                this.setState({
                                  notes: event.target.value,
                                });
                              }}
                            ></Input>
                          </FormGroup>
                        </Col>
                      </Row>
                      {this.state.Camp.value && (
                        <>
                          <Row>
                            <Col xl={6} lg={6} md={6} sm={6}>
                              <FormGroup>
                                <CustomInput
                                  id="cashpayment"
                                  type="radio"
                                  label="Cash Payment"
                                  checked={this.state.cashPayment}
                                  name="payment1"
                                  onClick={() =>
                                    this.setState({
                                      cashPayment: true,
                                    })
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col xl={6} lg={6} md={6} sm={6}>
                              <FormGroup>
                                <CustomInput
                                  id="cardpayment"
                                  type="radio"
                                  label="Credit card payment"
                                  checked={!this.state.cashPayment}
                                  name="payment1"
                                  onClick={() =>
                                    this.setState({
                                      cashPayment: false,
                                    })
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          {!this.state.cashPayment ? (
                            <Row>
                              <Col xl={12} lg={12} md={12}>
                                <FormGroup>
                                  <Label>Select Credit Card</Label>
                                  <Select
                                    placeholder="Select the credit card"
                                    value={this.state.selectedCreditCard}
                                    options={this.state.allCreditCardOptions}
                                    onChange={(result) =>
                                      this.setState({
                                        selectedCreditCard: result,
                                      })
                                    }
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                          ) : null}
                          <Row>
                            <Col xl={6} lg={6} md={6} sm={6}>
                              <FormGroup>
                                <CustomInput
                                  id="fullpayment"
                                  type="radio"
                                  label="Full Payment"
                                  checked={this.state.fullPayment}
                                  name="payment"
                                  onClick={() =>
                                    this.setState({
                                      fullPayment: true,
                                    })
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col xl={6} lg={6} md={6} sm={6}>
                              <FormGroup>
                                <CustomInput
                                  id="installmentpayment"
                                  type="radio"
                                  label="Installment payment"
                                  checked={!this.state.fullPayment}
                                  name="payment"
                                  onClick={() =>
                                    this.setState({
                                      fullPayment: false,
                                    })
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </>
                      )}
                      {!this.state.fullPayment && (
                        <>
                          <Row>
                            <Col xl={12} lg={12} md={12} sm={12}>
                              <FormGroup>
                                <Label for="installments">
                                  Select Installments :
                                </Label>
                                <CustomInput
                                  type="select"
                                  id="installments"
                                  name="selectInstallments"
                                  defaultValue={"0"}
                                  value={this.state.installments}
                                  onChange={(event) => {
                                    event.persist();
                                    let key =
                                      event.target.value >
                                      parseInt(this.state.installments || 0)
                                        ? "add"
                                        : "remove";
                                    this.setState(
                                      {
                                        installments: Number(
                                          event.target.value
                                        ),
                                      },
                                      () => this.installmentDates(key)
                                    );
                                  }}
                                >
                                  <option value="0" disabled>
                                    Select the value
                                  </option>
                                  <option value="2">2</option>
                                  <option value="3">3</option>
                                  <option value="4">4</option>
                                  <option value="5">5</option>
                                  <option value="6">6</option>
                                  <option value="7">7</option>
                                  <option value="8">8</option>
                                  <option value="9">9</option>
                                  <option value="10">10</option>
                                  <option value="11">11</option>
                                </CustomInput>
                              </FormGroup>
                            </Col>
                          </Row>
                          {this.state.installments ? (
                            <Row>
                              <Col xl={12} lg={12} md={12} sm={12}>
                                <div className="ml-4">
                                  <Input
                                    type="checkbox"
                                    style={{ width: "15px", height: "15px" }}
                                    checked={this.state.installmentDateShow}
                                    onChange={async (event) => {
                                      this.setState(
                                        {
                                          installmentDateShow: !this.state
                                            .installmentDateShow,
                                        },
                                        () => {
                                          this.state.installmentDateShow ===
                                            true &&
                                            this.installmentDates("add");
                                        }
                                      );
                                    }}
                                  ></Input>
                                  <Label>Set Custom Installment Dates</Label>
                                </div>
                              </Col>
                            </Row>
                          ) : null}
                          {this.state.installmentDateShow && (
                            <Row>
                              <Col xl={12} lg={12} md={12} sm={12}>
                                <Label>Installment Dates :</Label>
                                {this.state.installmentDates &&
                                this.state.installmentDates.length > 0
                                  ? this.state.installmentDates.map(
                                      (installmentDate, index) => (
                                        <div className="mt-2 mb-3" key={index}>
                                          {index === 0 ? (
                                            <>
                                              <Label>
                                                Payment {index} :
                                                {this.state.cashPayment
                                                  ? " (Payment using cash)"
                                                  : " (Payment using credit card)"}
                                              </Label>
                                              <Input
                                                type="number"
                                                min="0"
                                                required={
                                                  this.state.installmentDateShow
                                                }
                                                value={installmentDate.price}
                                                onChange={(event) => {
                                                  // let camp =
                                                  this.state.allCamps.find(
                                                    (camp) =>
                                                      camp._id ===
                                                      this.state.Camp.value
                                                  );
                                                  // if (
                                                  //   event.target.value >= 0 &&
                                                  //   event.target.value <=
                                                  //   camp.price
                                                  // ) {
                                                  let installmentDates = cloneDeep(
                                                    this.state.installmentDates
                                                  );
                                                  installmentDates[
                                                    index
                                                  ].price = Number(
                                                    event.target.value
                                                  );
                                                  this.setState({
                                                    installmentDates: installmentDates,
                                                  });
                                                  // }
                                                }}
                                              ></Input>
                                              {this.state.includeDueAmount ? (
                                                <div className="mt-2 mb-3">
                                                  <Label>
                                                    Past Due Amount :
                                                  </Label>
                                                  <Input
                                                    type="number"
                                                    disabled
                                                    value={this.state.dueAmount}
                                                  ></Input>
                                                </div>
                                              ) : null}
                                              {this.state.useCreditAmount ? (
                                                <div className="mt-2 mb-3">
                                                  <Label>Credit Amount :</Label>
                                                  <Input
                                                    type="number"
                                                    disabled
                                                    value={
                                                      this.state.creditAmount
                                                    }
                                                  ></Input>
                                                </div>
                                              ) : null}
                                              {this.state.includeDueAmount ||
                                              this.state.useCreditAmount ? (
                                                <div className="mt-2 mb-3">
                                                  <Label>Total Price :</Label>
                                                  <Input
                                                    type="number"
                                                    disabled
                                                    value={this.getTotalPrice()}
                                                  ></Input>
                                                </div>
                                              ) : null}
                                            </>
                                          ) : (
                                            <>
                                              <Label>
                                                Payment {index} : (Payment using
                                                credit card)
                                              </Label>
                                              <Input
                                                type="date"
                                                value={
                                                  moment(
                                                    new Date(
                                                      installmentDate.date
                                                    )
                                                  ).format("YYYY-MM-DD") || ""
                                                }
                                                onChange={(event) => {
                                                  let dates = this.state
                                                    .installmentDates;
                                                  let date = new Date(
                                                    event.target.value
                                                  ).setUTCHours(12);
                                                  dates[index].date = date;
                                                  this.setState({
                                                    installmentDates: dates,
                                                  });
                                                }}
                                                required={
                                                  this.state.installmentDateShow
                                                }
                                              ></Input>
                                            </>
                                          )}
                                        </div>
                                      )
                                    )
                                  : null}
                              </Col>
                            </Row>
                          )}
                        </>
                      )}
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        color="secondary"
                        onClick={(event) =>
                          this.toggleCampPaymentConfirmationModal()
                        }
                      >
                        Cancel
                      </Button>
                      <Button
                        color="primary"
                        onClick={(event) => {
                          this.payForEvent();
                        }}
                      >
                        Pay
                      </Button>
                    </ModalFooter>
                  </Modal>
                ) : null}
                {this.state.linkAccountModal ? (
                  <Modal
                    isOpen={this.state.linkAccountModal}
                    toggle={(event) => this.toggleLinkAccountModal()}
                    className="modal-lg"
                  >
                    <ModalHeader
                      toggle={(event) => this.toggleLinkAccountModal()}
                    >
                      Link Account
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={(event) => this.getAccountsForLinking(event)}
                      >
                        <Row className="mb-3">
                          <Col md={6}>
                            <Input
                              type="search"
                              value={this.state.globalSearchData}
                              placeholder="Search"
                              onChange={(event) =>
                                this.setState({
                                  globalSearchData: event.target.value,
                                })
                              }
                            />
                          </Col>
                          <Col md={4}>
                            <Button>Search</Button>
                          </Col>
                        </Row>
                      </Form>
                      <Row>
                        <Col>
                          <Table striped hover responsive>
                            <thead>
                              <tr>
                                <th>Select</th>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>Email</th>
                                <th>Phone</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.linkAccountUsers.length > 0 ? (
                                this.state.linkAccountUsers.map(
                                  (user, index) => (
                                    <tr key={index}>
                                      <td>
                                        <CustomInput
                                          id={index}
                                          type="radio"
                                          checked={
                                            this.state
                                              .selectedLinkedAdultIndex ===
                                            index
                                              ? true
                                              : false
                                          }
                                          name={`radio_${index}`}
                                          onClick={(event) => {
                                            this.setState({
                                              linkAccountUser: user,
                                              selectedLinkedAdultIndex: index,
                                            });
                                          }}
                                        />
                                      </td>
                                      <td>{user.data.firstName}</td>
                                      <td>{user.data.lastName}</td>
                                      <td>{user.data.email}</td>
                                      <td>{user.data.phone}</td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td colSpan="5" className="text-center">
                                    No Parents found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </Col>
                      </Row>
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        color="secondary"
                        onClick={(event) => this.toggleLinkAccountModal()}
                      >
                        Cancel
                      </Button>
                      <Button
                        color="primary"
                        disabled={!this.state.linkAccountUser}
                        onClick={(event) => {
                          this.toggleLinkAccountConfirmantModal();
                        }}
                      >
                        Link Account
                      </Button>
                    </ModalFooter>
                  </Modal>
                ) : null}
                {this.state.linkAccountConfirmantModal ? (
                  <Modal
                    isOpen={this.state.linkAccountConfirmantModal}
                    toggle={(event) => this.toggleLinkAccountConfirmantModal()}
                    className="modal-md"
                  >
                    <ModalHeader
                      toggle={(event) =>
                        this.toggleLinkAccountConfirmantModal()
                      }
                    >
                      Link Account
                    </ModalHeader>
                    <ModalBody>
                      Are you sure you want to link account?
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        color="secondary"
                        onClick={(event) =>
                          this.toggleLinkAccountConfirmantModal()
                        }
                      >
                        Cancel
                      </Button>
                      <Button
                        color="primary"
                        onClick={(event) => {
                          this.linkAccount();
                        }}
                      >
                        Link Account
                      </Button>
                    </ModalFooter>
                  </Modal>
                ) : null}
                {this.state.sendNotificaitonModal ? (
                  <Modal
                    isOpen={this.state.sendNotificaitonModal}
                    toggle={(event) => this.toggleSendNotificaitonModal()}
                    className="modal-md"
                  >
                    <ModalHeader
                      toggle={(event) => this.toggleSendNotificaitonModal()}
                    >
                      Are you sure you want to send notificaiton?
                    </ModalHeader>
                    <Form
                      onSubmit={(event) => this.sendNotificaitonToPlayer(event)}
                    >
                      <ModalBody>
                        <Row>
                          <Col xl={12} lg={12} md={12}>
                            <FormGroup>
                              <Label>Note</Label>
                              <Input
                                required
                                type="text"
                                placeholder="Enter the note"
                                value={this.state.sendNotificaitonMessage}
                                onChange={(event) =>
                                  this.setState({
                                    sendNotificaitonMessage: event.target.value,
                                  })
                                }
                              ></Input>
                            </FormGroup>
                          </Col>
                        </Row>
                      </ModalBody>
                      <ModalFooter>
                        <Button
                          color="secondary"
                          onClick={() => this.toggleSendNotificaitonModal()}
                        >
                          Cancel
                        </Button>{" "}
                        <Button color="primary" type="submit">
                          Send Notification
                        </Button>
                      </ModalFooter>
                    </Form>
                  </Modal>
                ) : null}
              </Card>
            </Col>
          </Row>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}
export default RushPlayerDetail;
